if (
    navigator.userAgent.includes("Macintosh") &&
    navigator.userAgent.includes("Safari") &&
    !navigator.userAgent.includes("Chrome")
) {
    document.documentElement.classList.add("safari-mac");
}

function getDefaultExportFromCjs(x) {
    return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, "default") ? x["default"] : x;
}
let browser = { exports: {} };

(function (module, exports) {
    Object.defineProperty(exports, "__esModule", {
        value: true,
    });
    exports.default = void 0;

    /**
     * DOM event delegator
     *
     * The delegator will listen
     * for events that bubble up
     * to the root node.
     *
     * @constructor
     * @param {Node|string} [root] The root node or a selector string matching the root node
     */
    function Delegate(root) {
        /**
         * Maintain a map of listener
         * lists, keyed by event name.
         *
         * @type Object
         */
        this.listenerMap = [{}, {}];

        if (root) {
            this.root(root);
        }
        /** @type function() */

        this.handle = Delegate.prototype.handle.bind(this); // Cache of event listeners removed during an event cycle

        this._removedListeners = [];
    }
    /**
     * Start listening for events
     * on the provided DOM element
     *
     * @param  {Node|string} [root] The root node or a selector string matching the root node
     * @returns {Delegate} This method is chainable
     */

    Delegate.prototype.root = function (root) {
        let listenerMap = this.listenerMap;
        let eventType; // Remove master event listeners

        if (this.rootElement) {
            for (eventType in listenerMap[1]) {
                if (listenerMap[1].hasOwnProperty(eventType)) {
                    this.rootElement.removeEventListener(eventType, this.handle, true);
                }
            }

            for (eventType in listenerMap[0]) {
                if (listenerMap[0].hasOwnProperty(eventType)) {
                    this.rootElement.removeEventListener(eventType, this.handle, false);
                }
            }
        } // If no root or root is not
        // a dom node, then remove internal
        // root reference and exit here

        if (!root || !root.addEventListener) {
            if (this.rootElement) {
                delete this.rootElement;
            }

            return this;
        }
        /**
         * The root node at which
         * listeners are attached.
         *
         * @type Node
         */

        this.rootElement = root; // Set up master event listeners

        for (eventType in listenerMap[1]) {
            if (listenerMap[1].hasOwnProperty(eventType)) {
                this.rootElement.addEventListener(eventType, this.handle, true);
            }
        }

        for (eventType in listenerMap[0]) {
            if (listenerMap[0].hasOwnProperty(eventType)) {
                this.rootElement.addEventListener(eventType, this.handle, false);
            }
        }

        return this;
    };
    /**
     * @param {string} eventType
     * @returns boolean
     */

    Delegate.prototype.captureForType = function (eventType) {
        return ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(eventType) !== -1;
    };
    /**
     * Attach a handler to one
     * event for all elements
     * that match the selector,
     * now or in the future
     *
     * The handler function receives
     * three arguments: the DOM event
     * object, the node that matched
     * the selector while the event
     * was bubbling and a reference
     * to itself. Within the handler,
     * 'this' is equal to the second
     * argument.
     *
     * The node that actually received
     * the event can be accessed via
     * 'event.target'.
     *
     * @param {string} eventType Listen for these events
     * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
     * @param {function()} handler Handler function - event data passed here will be in event.data
     * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
     * @returns {Delegate} This method is chainable
     */

    Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
        let root;
        let listenerMap;
        let matcher;
        let matcherParam;

        if (!eventType) {
            throw new TypeError("Invalid event type: " + eventType);
        } // handler can be passed as
        // the second or third argument

        if (typeof selector === "function") {
            useCapture = handler;
            handler = selector;
            selector = null;
        } // Fallback to sensible defaults
        // if useCapture not set

        if (useCapture === undefined) {
            useCapture = this.captureForType(eventType);
        }

        if (typeof handler !== "function") {
            throw new TypeError("Handler must be a type of Function");
        }

        root = this.rootElement;
        listenerMap = this.listenerMap[useCapture ? 1 : 0]; // Add master handler for type if not created yet

        if (!listenerMap[eventType]) {
            if (root) {
                root.addEventListener(eventType, this.handle, useCapture);
            }

            listenerMap[eventType] = [];
        }

        if (!selector) {
            matcherParam = null; // COMPLEX - matchesRoot needs to have access to
            // this.rootElement, so bind the function to this.

            matcher = matchesRoot.bind(this); // Compile a matcher for the given selector
        } else if (/^[a-z]+$/i.test(selector)) {
            matcherParam = selector;
            matcher = matchesTag;
        } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
            matcherParam = selector.slice(1);
            matcher = matchesId;
        } else {
            matcherParam = selector;
            matcher = Element.prototype.matches;
        } // Add to the list of listeners

        listenerMap[eventType].push({
            selector: selector,
            handler: handler,
            matcher: matcher,
            matcherParam: matcherParam,
        });
        return this;
    };
    /**
     * Remove an event handler
     * for elements that match
     * the selector, forever
     *
     * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
     * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
     * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
     * @returns {Delegate} This method is chainable
     */

    Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
        let i;
        let listener;
        let listenerMap;
        let listenerList;
        let singleEventType; // Handler can be passed as
        // the second or third argument

        if (typeof selector === "function") {
            useCapture = handler;
            handler = selector;
            selector = null;
        } // If useCapture not set, remove
        // all event listeners

        if (useCapture === undefined) {
            this.off(eventType, selector, handler, true);
            this.off(eventType, selector, handler, false);
            return this;
        }

        listenerMap = this.listenerMap[useCapture ? 1 : 0];

        if (!eventType) {
            for (singleEventType in listenerMap) {
                if (listenerMap.hasOwnProperty(singleEventType)) {
                    this.off(singleEventType, selector, handler);
                }
            }

            return this;
        }

        listenerList = listenerMap[eventType];

        if (!listenerList || !listenerList.length) {
            return this;
        } // Remove only parameter matches
        // if specified

        for (i = listenerList.length - 1; i >= 0; i--) {
            listener = listenerList[i];

            if ((!selector || selector === listener.selector) && (!handler || handler === listener.handler)) {
                this._removedListeners.push(listener);

                listenerList.splice(i, 1);
            }
        } // All listeners removed

        if (!listenerList.length) {
            delete listenerMap[eventType]; // Remove the main handler

            if (this.rootElement) {
                this.rootElement.removeEventListener(eventType, this.handle, useCapture);
            }
        }

        return this;
    };
    /**
     * Handle an arbitrary event.
     *
     * @param {Event} event
     */

    Delegate.prototype.handle = function (event) {
        let i;
        let l;
        let type = event.type;
        let root;
        let phase;
        let listener;
        let returned;
        let listenerList = [];
        let target;
        let eventIgnore = "ftLabsDelegateIgnore";

        if (event[eventIgnore] === true) {
            return;
        }

        target = event.target; // Hardcode value of Node.TEXT_NODE
        // as not defined in IE8

        if (target.nodeType === 3) {
            target = target.parentNode;
        } // Handle SVG <use> elements in IE

        if (target.correspondingUseElement) {
            target = target.correspondingUseElement;
        }

        root = this.rootElement;
        phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2); // eslint-disable-next-line default-case

        switch (phase) {
            case 1:
                //Event.CAPTURING_PHASE:
                listenerList = this.listenerMap[1][type];
                break;

            case 2:
                //Event.AT_TARGET:
                if (this.listenerMap[0] && this.listenerMap[0][type]) {
                    listenerList = listenerList.concat(this.listenerMap[0][type]);
                }

                if (this.listenerMap[1] && this.listenerMap[1][type]) {
                    listenerList = listenerList.concat(this.listenerMap[1][type]);
                }

                break;

            case 3:
                //Event.BUBBLING_PHASE:
                listenerList = this.listenerMap[0][type];
                break;
        }

        let toFire = []; // Need to continuously check
        // that the specific list is
        // still populated in case one
        // of the callbacks actually
        // causes the list to be destroyed.

        l = listenerList.length;

        while (target && l) {
            for (i = 0; i < l; i++) {
                listener = listenerList[i]; // Bail from this loop if
                // the length changed and
                // no more listeners are
                // defined between i and l.

                if (!listener) {
                    break;
                }

                if (
                    target.tagName &&
                    ["button", "input", "select", "textarea"].indexOf(target.tagName.toLowerCase()) > -1 &&
                    target.hasAttribute("disabled")
                ) {
                    // Remove things that have previously fired
                    toFire = [];
                } // Check for match and fire
                // the event if there's one
                //
                // TODO:MCG:20120117: Need a way
                // to check if event#stopImmediatePropagation
                // was called. If so, break both loops.
                else if (listener.matcher.call(target, listener.matcherParam, target)) {
                    toFire.push([event, target, listener]);
                }
            } // TODO:MCG:20120117: Need a way to
            // check if event#stopPropagation
            // was called. If so, break looping
            // through the DOM. Stop if the
            // delegation root has been reached

            if (target === root) {
                break;
            }

            l = listenerList.length; // Fall back to parentNode since SVG children have no parentElement in IE

            target = target.parentElement || target.parentNode; // Do not traverse up to document root when using parentNode, though

            if (target instanceof HTMLDocument) {
                break;
            }
        }

        let ret;

        for (i = 0; i < toFire.length; i++) {
            // Has it been removed during while the event function was fired
            if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
                continue;
            }

            returned = this.fire.apply(this, toFire[i]); // Stop propagation to subsequent
            // callbacks if the callback returned
            // false

            if (returned === false) {
                toFire[i][0][eventIgnore] = true;
                toFire[i][0].preventDefault();
                ret = false;
                break;
            }
        }

        return ret;
    };
    /**
     * Fire a listener on a target.
     *
     * @param {Event} event
     * @param {Node} target
     * @param {Object} listener
     * @returns {boolean}
     */

    Delegate.prototype.fire = function (event, target, listener) {
        return listener.handler.call(target, event, target);
    };
    /**
     * Check whether an element
     * matches a tag selector.
     *
     * Tags are NOT case-sensitive,
     * except in XML (and XML-based
     * languages such as XHTML).
     *
     * @param {string} tagName The tag name to test against
     * @param {Element} element The element to test with
     * @returns boolean
     */

    function matchesTag(tagName, element) {
        return tagName.toLowerCase() === element.tagName.toLowerCase();
    }
    /**
     * Check whether an element
     * matches the root.
     *
     * @param {?String} selector In this case this is always passed through as null and not used
     * @param {Element} element The element to test with
     * @returns boolean
     */

    function matchesRoot(selector, element) {
        if (this.rootElement === window) {
            return (
                // Match the outer document (dispatched from document)
                element === document || // The <html> element (dispatched from document.body or document.documentElement)
                element === document.documentElement || // Or the window itself (dispatched from window)
                element === window
            );
        }

        return this.rootElement === element;
    }
    /**
     * Check whether the ID of
     * the element in 'this'
     * matches the given ID.
     *
     * IDs are case-sensitive.
     *
     * @param {string} id The ID to test against
     * @param {Element} element The element to test with
     * @returns boolean
     */

    function matchesId(id, element) {
        return id === element.id;
    }
    /**
     * Short hand for off()
     * and root(), ie both
     * with no parameters
     *
     * @return void
     */

    Delegate.prototype.destroy = function () {
        this.off();
        this.root();
    };

    let _default = Delegate;
    exports.default = _default;
    module.exports = exports.default;
})(browser, browser.exports);

const Delegate = /*@__PURE__*/ getDefaultExportFromCjs(browser.exports);

// Define the Section constructor function
/**
 * Creates a new Section instance.
 *
 * @param {Element} container - The container element for the section.
 * @param {Object} properties - The properties object for the section.
 * @returns {Section} - The newly created Section instance.
 */
function Section(container, properties) {
    this.container = validateContainerElement(container);
    this.id = container.getAttribute(SECTION_ID_ATTR);
    this.extensions = [];

    // eslint-disable-next-line es5/no-es6-static-methods
    Object.assign(this, validatePropertiesObject(properties));

    this.onLoad();
}

// Define the prototype methods for the Section constructor
Section.prototype = {
    // Default empty functions for the section lifecycle events
    onLoad: Function.prototype,
    onUnload: Function.prototype,
    onSelect: Function.prototype,
    onDeselect: Function.prototype,
    onBlockSelect: Function.prototype,
    onBlockDeselect: Function.prototype,

    // Extend method to add additional functionality to the section
    /**
     * Extends the Section instance with additional functionality.
     *
     * @param {Object} extension - The extension object to add.
     */
    extend: function extend(extension) {
        this.extensions.push(extension); // Save original extension

        // eslint-disable-next-line es5/no-es6-static-methods
        let extensionClone = Object.assign({}, extension);
        delete extensionClone.init; // Remove init function before assigning extension properties

        // eslint-disable-next-line es5/no-es6-static-methods
        Object.assign(this, extensionClone);

        if (typeof extension.init === "function") {
            extension.init.apply(this);
        }
    },
};

/**
 * Validates a container element for theme sections.
 *
 * @param {Element} container - The container element to be validated.
 * @throws {TypeError} - If the container is not a DOM element.
 * @throws {Error} - If the container lacks the required attribute.
 * @return {Element} - The validated container element.
 */
function validateContainerElement(container) {
    // Check if the container is a DOM element.
    if (!(container instanceof Element)) {
        throw new TypeError(
            "Theme Sections: Attempted to load section. The section container provided is not a DOM element.",
        );
    }

    // Check if the container has the required attribute.
    if (container.getAttribute(SECTION_ID_ATTR) === null) {
        throw new Error(
            "Theme Sections: The section container provided does not have an id assigned to the " +
                SECTION_ID_ATTR +
                " attribute.",
        );
    }

    // Return the validated container element.
    return container;
}

/**
 * Validates a properties object for theme sections.
 *
 * @param {Object} value - The properties object to be validated.
 * @throws {TypeError} - If the value is not an object or is null.
 * @return {Object} - The validated properties object.
 */
function validatePropertiesObject(value) {
    // Check if the value is either undefined or not an object (excluding null).
    if ((typeof value !== "undefined" && typeof value !== "object") || value === null) {
        throw new TypeError("Theme Sections: The properties object provided is not a valid");
    }

    // Return the validated properties object.
    return value;
}

// Object.assign() polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign#Polyfill
if (typeof Object.assign != "function") {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
        value: function assign(target) {
            if (target == null) {
                // TypeError if undefined or null
                throw new TypeError("Cannot convert undefined or null to object");
            }

            let to = Object(target);

            for (let index = 1; index < arguments.length; index++) {
                let nextSource = arguments[index];

                if (nextSource != null) {
                    // Skip over if undefined or null
                    for (let nextKey in nextSource) {
                        // Avoid bugs when hasOwnProperty is shadowed
                        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                            to[nextKey] = nextSource[nextKey];
                        }
                    }
                }
            }
            return to;
        },
        writable: true,
        configurable: true,
    });
}

/*
 * @shopify/theme-sections
 * -----------------------------------------------------------------------------
 *
 * A framework to provide structure to your Shopify sections and a load and unload
 * lifecycle. The lifecycle is automatically connected to theme editor events so
 * that your sections load and unload as the editor changes the content and
 * settings of your sections.
 */

const SECTION_TYPE_ATTR = "data-section-type";
const SECTION_ID_ATTR = "data-section-id";

window.Shopify = window.Shopify || {};
window.Shopify.theme = window.Shopify.theme || {};
window.Shopify.theme.sections = window.Shopify.theme.sections || {};

const registered = (window.Shopify.theme.sections.registered = window.Shopify.theme.sections.registered || {});
const instances = (window.Shopify.theme.sections.instances = window.Shopify.theme.sections.instances || []);

/**
 * Checks if the local storage is available
 *
 * @returns {boolean}
 */
function localStorageAvailable() {
    const test = "test";
    try {
        localStorage.setItem(test, test);
        if (localStorage.getItem(test) !== test) {
            return false;
        }
        localStorage.removeItem(test);
        return true;
    } catch (e) {
        return false;
    }
}

const PREFIX = "AFND__";
function getStorage(key) {
    if (!localStorageAvailable()) return null;
    return JSON.parse(localStorage.getItem(PREFIX + key));
}
function hasStorage(key) {
    if (!localStorageAvailable()) return false;
    return localStorage.getItem(PREFIX + key) !== null;
}
function removeStorage(key) {
    if (!localStorageAvailable()) return null;
    localStorage.removeItem(PREFIX + key);
    return true;
}
function setStorage(key, val) {
    if (!localStorageAvailable()) return null;
    localStorage.setItem(PREFIX + key, val);
    return true;
}

/**
 *
 * If the `node` has class 'animation' and the element does not have class `prefers-reduced-motion`
 * return true
 *
 * @param {HTMLElement} node
 * @returns {Boolean}
 */
const shouldAnimate = (node) => {
    return hasClass(node, "animation") && !hasClass(document.documentElement, "prefers-reduced-motion");
};

/**
 *
 * ### **Registers a new section type with the provided properties.**
 *
 * @param {string} type - The type of the section being registered.
 * @param {Object} properties - The properties for the registered section.
 * @throws {TypeError} - If the type argument is not a string.
 * @throws {Error} - If a section of the same type has already been registered.
 * @return {Function} - The constructor function for the registered section.
 */
function register(type, properties) {
    if (typeof type !== "string") {
        throw new TypeError(
            "Theme Sections: The first argument for .register must be a string that specifies the type of the section being registered",
        );
    }

    if (typeof registered[type] !== "undefined") {
        throw new Error(
            'Theme Sections: A section of type "' +
                type +
                '" has already been registered. You cannot register the same section type twice',
        );
    }

    function TypedSection(container) {
        Section.call(this, container, properties);
    }

    TypedSection.constructor = Section;
    TypedSection.prototype = Object.create(Section.prototype);
    TypedSection.prototype.type = type;
    return (registered[type] = TypedSection);
}

/**
 * Load sections based on provided types and containers.
 *
 * @param {string|string[]} types - The type(s) of sections to load.
 * @param {Element[]|NodeList} containers - The container element(s) to load sections into.
 */
function load(types, containers) {
    types = normalizeType(types);

    if (typeof containers === "undefined") {
        containers = document.querySelectorAll("[" + SECTION_TYPE_ATTR + "]");
    }

    containers = normalizeContainers(containers);

    types.forEach(function (type) {
        const TypedSection = registered[type];

        if (typeof TypedSection === "undefined") {
            return;
        }

        containers = containers.filter(function (container) {
            // Filter from list of containers because container already has an instance loaded
            if (isInstance(container)) {
                return false;
            }

            // Filter from list of containers because container doesn't have data-section-type attribute
            if (container.getAttribute(SECTION_TYPE_ATTR) === null) {
                return false;
            }

            // Keep in list of containers because current type doesn't match
            if (container.getAttribute(SECTION_TYPE_ATTR) !== type) {
                return true;
            }

            instances.push(new TypedSection(container));

            // Filter from list of containers because container now has an instance loaded
            return false;
        });
    });
}

/**
 * Unload sections based on the provided selector.
 *
 * @param {string|Element|Element[]} selector - The selector or element(s) to identify sections to unload.
 */
function unload(selector) {
    const instancesToUnload = getInstances(selector);

    instancesToUnload.forEach(function (instance) {
        let index = instances
            .map(function (e) {
                return e.id;
            })
            .indexOf(instance.id);
        instances.splice(index, 1);
        instance.onUnload();
    });
}

/**
 * Get instances based on the provided selector.
 *
 * @param {string|Element|Element[]} selector - The selector or element(s) to identify instances.
 * @returns {Section[]} - An array of Section instances.
 */
function getInstances(selector) {
    let filteredInstances = [];
    let firstElement;
    // Fetch the first element if it's an array
    if (NodeList.prototype.isPrototypeOf(selector) || Array.isArray(selector)) {
        firstElement = selector[0];
    }

    // If the selector element is a DOM element
    if (selector instanceof Element || firstElement instanceof Element) {
        let containers = normalizeContainers(selector);

        containers.forEach(function (container) {
            // Filter instances based on the container element
            filteredInstances = filteredInstances.concat(
                instances.filter(function (instance) {
                    return instance.container === container;
                }),
            );
        });

        // If the selector is a type string
    } else if (typeof selector === "string" || typeof firstElement === "string") {
        let types = normalizeType(selector);

        types.forEach(function (type) {
            // Filter instances based on the section type
            filteredInstances = filteredInstances.concat(
                instances.filter(function (instance) {
                    return instance.type === type;
                }),
            );
        });
    }

    return filteredInstances;
}

/**
 * Get an instance based on the provided ID.
 *
 * @param {string} id - The ID of the section instance to retrieve.
 * @returns {Section|null} - The Section instance or null if not found.
 */
function getInstanceById(id) {
    let instance;

    for (let i = 0; i < instances.length; i++) {
        if (instances[i].id === id) {
            instance = instances[i];
            break;
        }
    }
    return instance;
}

/**
 * Check if an instance exists based on the provided selector.
 *
 * @param {string|Element|Element[]} selector - The selector or element(s) to check for instances.
 * @returns {boolean} - True if an instance exists, false otherwise.
 */
function isInstance(selector) {
    return getInstances(selector).length > 0;
}

/**
 * Normalize section types.
 *
 * @param {string|string[]|Section|Section[]} types - The section type(s) to normalize.
 * @returns {string[]} - An array of normalized section types.
 */
function normalizeType(types) {
    // If '*' then fetch all registered section types
    if (types === "*") {
        types = Object.keys(registered);
        // If a single section type string is passed, put it in an array
    } else if (typeof types === "string") {
        types = [types];
        // If a single section constructor is passed, transform to an array with the section type string
    } else if (types.constructor === Section) {
        types = [types.prototype.type];
        // If an array of typed section constructors is passed, transform the array to type strings
    } else if (Array.isArray(types) && types[0].constructor === Section) {
        types = types.map(function (TypedSection) {
            return TypedSection.prototype.type;
        });
    }

    // Convert types to lowercase
    types = types.map(function (type) {
        return type.toLowerCase();
    });

    return types;
}

/**
 * Normalize containers.
 *
 * @param {Element|Element[]|NodeList|null} containers - The container(s) to normalize.
 * @returns {Element[]} - An array of normalized container elements.
 */
function normalizeContainers(containers) {
    // Nodelist with entries
    if (NodeList.prototype.isPrototypeOf(containers) && containers.length > 0) {
        containers = Array.prototype.slice.call(containers);
        // Empty Nodelist
    } else if (NodeList.prototype.isPrototypeOf(containers) && containers.length === 0) {
        containers = [];
        // Handle null (document.querySelector() returns null with no match)
    } else if (containers === null) {
        containers = [];
        // Single DOM element
    } else if (!Array.isArray(containers) && containers instanceof Element) {
        containers = [containers];
    }

    return containers;
}

if (window.Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
        let container;
        let id = event.detail.sectionId;

        if (window.Shopify.visualPreviewMode) {
            container = event.target.querySelector("[data-section-id]");
        } else {
            container = event.target.querySelector("[" + SECTION_ID_ATTR + '="' + id + '"]');
        }

        if (container !== null) {
            load(container.getAttribute(SECTION_TYPE_ATTR), container);
        }
    });

    document.addEventListener("shopify:section:unload", function (event) {
        let id = event.detail.sectionId;
        let container = event.target.querySelector("[" + SECTION_ID_ATTR + '="' + id + '"]');
        let instance = getInstances(container)[0];

        if (typeof instance === "object") {
            unload(container);
        }
    });

    document.addEventListener("shopify:section:select", function (event) {
        let instance = getInstanceById(event.detail.sectionId);
        if (typeof instance === "object" && instance.onSelect) {
            instance.onSelect(event);
        }
    });

    document.addEventListener("shopify:section:deselect", function (event) {
        let instance = getInstanceById(event.detail.sectionId);

        if (typeof instance === "object" && instance.onDeselect) {
            instance.onDeselect(event);
        }
    });

    document.addEventListener("shopify:block:select", function (event) {
        let instance = getInstanceById(event.detail.sectionId);

        if (typeof instance === "object" && instance.onBlockSelect) {
            instance.onBlockSelect(event);
        }
    });

    document.addEventListener("shopify:block:deselect", function (event) {
        let instance = getInstanceById(event.detail.sectionId);

        if (typeof instance === "object" && instance.onBlockDeselect) {
            instance.onBlockDeselect(event);
        }
    });
}

/**
 * Event emitter for custom events.
 * @type {EventEmitter}
 */
const eventEmitter = createEmitter(),
    /**
     * * function c (registerListener)
     * Registers a listener for the specified event.
     *
     * @param {string|string[]} eventNames - The name(s) of the event(s) to listen for.
     * @param {function} listenerFunction - The function to be called when the event is triggered.
     * @returns {function} - A function to unregister listeners.
     */
    registerListener = eventEmitter.on,
    /**
     * *  r$1 (triggerEvent)
     * Triggers an event using the event emitter.
     *
     * @param {string} eventName - The name of the event to trigger.
     * @param {object|function} eventData - The data to be passed to the event listeners.
     * @param {any} additionalArgument - An additional argument to be passed to the event listeners.
     */
    triggerEvent = eventEmitter.emit,
    /**
     * *  o$1 (updateState)
     * Updates the state using the event emitter's hydration method.
     * @param {EventEmitter} eventEmitter - The event emitter object.
     */
    updateState = eventEmitter.hydrate;

/**
 * * function a (createEmitter)
 * Creates an emitter object that allows registering event listeners, triggering events, and managing state.
 *
 * @param {object} initialState - The initial state object. Defaults to an empty object if not provided.
 * @returns {object} - The emitter object with methods to manage state and events.
 */
function createEmitter(initialState) {
    // If initialState is undefined, set it to an empty object
    void 0 === initialState && (initialState = {});

    // Create an empty object to store event listeners
    let listeners = {};
    return {
        /**
         * Returns a copy of the current state.
         *
         * @returns {object} - The current state.
         */
        getCurrentState: function () {
            return Object.assign({}, initialState);
        },
        /**
         * Updates the state with the provided object and triggers listeners.
         *
         * @param {object} newState - The new state object.
         * @returns {function} - A function to unregister listeners.
         */
        hydrate: function (newState) {
            // Validate and assign the initial state object
            validateState(newState);
            Object.assign(initialState, newState);

            // Return a function to unsubscribe event listeners
            return function () {
                let eventNames = ["*"].concat(Object.keys(newState));
                handleStateAndEvents(eventNames, listeners, initialState);
            };
        },
        /**
         * Registers event listeners.
         *
         * @param {string|string[]} eventNames - The name(s) of the event(s) to listen for.
         * @param {function} listenerFunction - The function to be called when the event is triggered.
         * @returns {function} - A function to unregister listeners.
         */
        on: function (eventNames, listenerFunction) {
            // Convert eventNames to an array if it's not already
            eventNames = [].concat(eventNames);
            // Add the event listener(s) to the listeners object
            eventNames.map((eventName) => {
                return (listeners[eventName] = (listeners[eventName] || []).concat(listenerFunction));
            });

            // Return a function to unregister listeners
            return function () {
                return eventNames.map((eventName) => {
                    return listeners[eventName].splice(listeners[eventName].indexOf(listenerFunction), 1);
                });
            };
        },
        /**
         * Triggers event listeners and updates the state.
         *
         * @param {string} eventName - The name of the event to trigger.
         * @param {object|function} eventData - The data to be passed to the event listeners.
         * @param {any} additionalArgument - An additional argument to be passed to the event listeners.
         */
        emit: function (eventName, eventData, additionalArgument) {
            // Create an array of events to emit
            let eventsToTrigger = ("*" === eventName ? [] : ["*"]).concat(eventName);

            // If 'eventData' is a function, call it with the current state, else use 'eventData' directly
            (eventData = "function" == typeof eventData ? eventData(initialState) : eventData) &&
                (validateState(eventData),
                Object.assign(initialState, eventData),
                (eventsToTrigger = eventsToTrigger.concat(Object.keys(eventData))));
            // Call the function handleEvents with the event array, listeners, state, and additional argument
            return handleStateAndEvents(eventsToTrigger, listeners, initialState, additionalArgument);
        },
    };
}

/* BASE FUNCTIONS */

/**
 * n$1 (validateState)
 *
 * ### **Validates the provided state object.**
 * @param {object} state - The state object to validate.
 * @throws Throws an error if the state is not an object.
 */
const validateState = function (state) {
    if (typeof (temp = state) !== "object" || Array.isArray(temp)) throw "state should be an object";
    var temp;
};

/**
 * t$1 (handleStateAndEvents)
 *
 * ### **Handles state updates and event listeners.**
 * @param {Array} eventTypes - An array of event types.
 * @param {object} eventHandlers - An object containing event handlers.
 * @param {object} currentState - The current state object.
 * @param {Function} updateFunction - The function to update the state.
 * @return {Array} - An array of results from event handlers.
 */
const handleStateAndEvents = function (eventTypesToTrigger, eventListeners, currentState, updateFunction) {
    return ((result = eventTypesToTrigger),
    result.reduce(function (eventTypesToTrigger, eventType, currentState) {
        return eventTypesToTrigger.indexOf(eventType) > -1
            ? eventTypesToTrigger
            : eventTypesToTrigger.concat(eventType);
    }, []))
        .reduce(function (eventTypesToTrigger, event) {
            return eventTypesToTrigger.concat(eventListeners[event] || []);
        }, [])
        .map(function (handler) {
            return handler(currentState, updateFunction);
        });
    var result;
};

/**
 * e$1 (createStateManagementObject)
 *
 * ### **Creates a state management object with CRUD operations.**
 * @param {object} initialState - The initial state object.
 * @return {object} - A state management object with getState, hydrate, on, and emit methods.
 */
const createStateManagementObject = function (initialState) {
    void 0 === initialState && (initialState = {});
    let eventHandlers = {};

    return {
        /**
         * getState
         *
         * ### **Gets a copy of the current state.**
         * @return {object} - A copy of the current state object.
         */
        getState: function () {
            return Object.assign({}, initialState);
        },

        /**
         * hydrate
         *
         * ### **Updates the state with a provided object and invokes event handlers.**
         * @param {object} update - The object with properties to update the state.
         * @return {Function} - A function to invoke event handlers for the updated state.
         */
        hydrate: function (update) {
            validateState(update);
            Object.assign(initialState, update);
            return function () {
                let eventTypes = ["*"].concat(Object.keys(update));
                handleStateAndEvents(eventTypes, eventHandlers, initialState, update);
            };
        },

        /**
         * on
         *
         * ### **Adds event listeners for specific event types.**
         * @param {Array|string} eventTypes - An array or a single string of event types.
         * @param {Function} eventHandler - The function to handle events.
         * @return {Function} - A function to remove the added event listeners.
         */
        on: function (eventTypes, eventHandler) {
            (eventTypes = [].concat(eventTypes)).map(function (eventType) {
                eventHandlers[eventType] = (eventHandlers[eventType] || []).concat(eventHandler);
            });
            return function () {
                return eventTypes.map(function (eventType) {
                    eventHandlers[eventType].splice(eventHandlers[eventType].indexOf(eventHandler), 1);
                });
            };
        },

        /**
         * emit
         *
         * ### **Emits events, updates the state, and invokes event handlers.**
         * @param {Array|string} eventTypes - An array or a single string of event types.
         * @param {Function|object} eventCallback - The function or object to handle events.
         * @param {Function} updateFunction - The function to update the state.
         */
        emit: function (eventTypes, eventCallback, updateFunction) {
            let eventsToEmit = ("*" === eventTypes ? [] : ["*"]).concat(eventTypes);
            (eventCallback = typeof eventCallback === "function" ? eventCallback(initialState) : eventCallback) &&
                (validateState(eventCallback),
                Object.assign(initialState, eventCallback),
                (eventsToEmit = eventsToEmit.concat(Object.keys(eventCallback))));
            handleStateAndEvents(eventsToEmit, eventHandlers, initialState, updateFunction);
        },
    };
};

// UTILITIES FUNCTIONS

function smoothScrollToTarget(target, otherHeights) {
    let scrollContainer = target;
    do {
        //find scroll container
        scrollContainer = scrollContainer.parentNode;
        if (!scrollContainer) return;
        scrollContainer.scrollTop += 1;
    } while (scrollContainer.scrollTop == 0);

    var targetY = 0;
    do {
        //find the top of target relatively to the container
        if (target == scrollContainer) break;
        targetY += target.offsetTop;
    } while ((target = target.offsetParent));

    scroll = function (c, a, b, i) {
        i++;
        if (i > 30) return;

        c.scrollTop = a + ((b - a) / 30) * i - otherHeights;

        setTimeout(function () {
            scroll(c, a, b, i);
        }, 20);
    };
    // start scrolling
    scroll(scrollContainer, scrollContainer.scrollTop, targetY, 0);
}

/**
 * Takes a selector and updates the innerHTML of that element with the contents found in the updated document
 * @param {*} selector The selector to target
 * @param {*} doc The updated document returned by the fetch request
 */
function updateInnerHTML(selector, doc) {
    const updatedItem = selectElement(selector, doc);
    const oldItem = selectElement(selector);

    if (updatedItem && oldItem) {
        oldItem.innerHTML = updatedItem.innerHTML;
    }
}

/**
 * Makes an HTTP request using XMLHttpRequest.
 *
 * @param {string} method - The HTTP method (e.g., 'GET', 'POST', 'PUT', 'DELETE').
 * @param {string} url - The URL to send the request to.
 * @returns {Promise} A promise that resolves with the response if the request is successful, or rejects with an error if the request fails.
 */
function makeRequest(method, url) {
    return new Promise(function (resolve, reject) {
        let xhr = new XMLHttpRequest();
        xhr.open(method, url);
        xhr.onload = function () {
            if (this.status >= 200 && this.status < 300) {
                resolve(xhr.response);
            } else {
                reject(new Error(this.status));
            }
        };
        xhr.onerror = function () {
            reject(new Error(this.status));
        };
        xhr.send();
    });
}

let previousXOffset,
    previousYOffset,
    previousInnerWidth,
    previousInnerHeight,
    currentXOffset,
    currentYOffset,
    currentInnerWidth,
    currentInnerHeight,
    callbacks = [];

/**
 * function w (trackWindowChanges)
 * Handles the scroll event and triggers callbacks when the scroll position or window dimensions change.
 *
 * @param {number} n - The number of callbacks to trigger.
 * @param {boolean} a - Flag indicating whether to force trigger the callbacks.
 */
function trackWindowChanges(n, a) {
    currentXOffset = window.pageXOffset;
    currentYOffset = window.pageYOffset;
    currentInnerWidth = window.innerWidth;
    currentInnerHeight = window.innerHeight;

    if (
        a ||
        currentYOffset !== previousYOffset ||
        currentXOffset !== previousXOffset ||
        currentInnerHeight !== previousInnerHeight ||
        currentInnerWidth !== previousInnerWidth
    ) {
        (function (n) {
            for (let i = 0; i < callbacks.length; i++) {
                callbacks[i](
                    {
                        x: currentXOffset,
                        y: currentYOffset,
                        px: previousXOffset,
                        py: previousYOffset,
                        vh: currentInnerHeight,
                        pvh: previousInnerHeight,
                        vw: currentInnerWidth,
                        pvw: previousInnerWidth,
                    },
                    n,
                );
            }
        })(n);
    }

    previousXOffset = currentXOffset;
    previousYOffset = currentYOffset;
    previousInnerHeight = currentInnerHeight;
    previousInnerWidth = currentInnerWidth;

    requestAnimationFrame(trackWindowChanges);
}

/**
 * srraf (observeWindowChanges)
 * Observes the scroll event and executes the provided callback function.
 * @param {Function} e - The callback function to be executed on scroll event.
 * @returns {Object} - An object with update and destroy methods.
 */
function observeWindowChanges(e) {
    if (callbacks.indexOf(e) < 0) {
        callbacks.push(e);
    }

    if (!previousXOffset) {
        previousXOffset = window.pageXOffset;
    }

    if (!previousYOffset) {
        previousYOffset = window.pageYOffset;
    }

    if (!previousInnerWidth) {
        previousInnerWidth = window.innerWidth;
    }

    if (!previousInnerHeight) {
        previousInnerHeight = window.innerHeight;
    }

    requestAnimationFrame(trackWindowChanges);

    return {
        update: function () {
            return (trackWindowChanges(performance.now(), true), this);
        },
        destroy: function () {
            callbacks.splice(callbacks.indexOf(e), 1);
        },
    };
}

/**
 * Watches for changes in the viewport width and triggers a callback function
 * when the viewport width is at or below a specified breakpoint.
 *
 * @param {number} breakpointToWatch - The breakpoint value in pixels.
 * @param {Function} callback - The callback function to be executed when the breakpoint is reached.
 * @returns {Object} - An object with an `unload` method to stop watching for changes.
 */
const atBreakpointChange = (breakpointToWatch, callback) => {
    /**
     * Checks if the screen width is under a specific breakpoint.
     * @returns {boolean} True if the screen width is under the breakpoint, false otherwise.
     */
    const _screenUnderBP = () => {
        const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
        return viewportWidth <= breakpointToWatch;
    };

    let screenUnderBP = _screenUnderBP();

    const widthWatcher = observeWindowChanges((_ref) => {
        let { vw } = _ref;

        const currentScreenWidthUnderBP = vw <= breakpointToWatch;

        if (currentScreenWidthUnderBP !== screenUnderBP) {
            screenUnderBP = currentScreenWidthUnderBP;
            return callback();
        }
    });

    const unload = () => {
        widthWatcher.destroy();
    };

    return {
        unload,
    };
};

/**
 * n$2 (selectElement)
 *
 * ### **Selects the first element that matches the specified selector.**
 * @param {string} selector - The CSS selector.
 * @param {HTMLElement} [context=document] - The context element to search within (alternative name: context).
 * @return {HTMLElement|null} - The first matching element or null if not found.
 */
function selectElement(selector, context) {
    return void 0 === context ? document.querySelector(selector) : context.querySelector(selector);
}

/**
 * t$2 (selectElements)
 *
 * ### **Selects all elements that match the specified selector.**
 * @param {string} selector - The CSS selector.
 * @param {HTMLElement} [context=document] - The context element to search within (alternative name: context).
 * @return {Array} - An array of matching elements.
 */
function selectElements(selector, context) {
    return void 0 === context
        ? [].slice.call(document.querySelectorAll(selector))
        : [].slice.call(context.querySelectorAll(selector));
}

/**
 * c$1 (iterateElements)
 *
 * ### **Iterates over elements and applies a function.**
 * @param {Array|HTMLElement} elements - An array of elements or a single element.
 * @param {Function} callback - The function to apply to each element.
 */
function iterateElements(elements, callback) {
    return Array.isArray(elements) ? elements.forEach(callback) : callback(elements);
}

/**
 * r$2 (addOrRemoveEventListeners)
 *
 * ### **Adds or removes event listeners.**
 * @param {string} action - The action to perform ("add" or "remove").
 * @return {Function} - A function to add or remove event listeners.
 */
function addOrRemoveEventListeners(action) {
    return function (elements, eventType, eventHandler) {
        return iterateElements(elements, function (t) {
            return t[action + "EventListener"](eventType, eventHandler);
        });
    };
}

/**
 * e$2 (addOrRemoveEventListener)
 *
 * ### **Adds or removes an event listener.**
 * @param {string} action - The action to perform ("add" or "remove").
 * @param {Array|HTMLElement} elements - An array of elements or a single element (alternative name: elements).
 * @param {string} eventType - The type of event (alternative name: eventType).
 * @param {Function} eventHandler - The function to be called when the event occurs (alternative name: eventHandler).
 * @return {Function} - A function to add or remove the event listener.
 */
function addOrRemoveEventListener(elements, eventType, eventHandler) {
    return (
        addOrRemoveEventListeners("add")(elements, eventType, eventHandler),
        function () {
            return addOrRemoveEventListeners("remove")(elements, eventType, eventHandler);
        }
    );
}

/**
 * o$2 (manipulateClassList)
 *
 * ### **Adds, removes, or toggles a class on elements.**
 * @param {string} action - The action to perform ("add", "remove", or "toggle").
 * @return {Function} - A function to add, remove, or toggle the class on elements.
 */
function manipulateClassList(action) {
    return function (elements) {
        let args = arguments;
        return iterateElements(elements, function (element) {
            let c;
            return (c = element.classList)[action].apply(c, [].slice.call(args, 1));
        });
    };
}

/**
 * u$1 (addClassToElements)
 *
 * ### **Adds a class to elements.**
 * @param {string} className - The class to add (alternative name: className).
 * @param {Array|HTMLElement} elements - An array of elements or a single element.
 */
function addClassToElements(elements) {
    manipulateClassList("add").apply(void 0, [elements].concat([].slice.call(arguments, 1)));
}

/**
 * i$1 (removeClassFromElements)
 *
 * ### **Removes a class from elements.**
 * @param {string} className - The class to remove (alternative name: className).
 *
 */
function removeClassFromElements(elements) {
    manipulateClassList("remove").apply(void 0, [elements].concat([].slice.call(arguments, 1)));
}

/**
 * function l (toggleClassOnElements)
 *
 * ### **Toggles a class on/off in elements.**
 * @param {string} className - The class to toggle (alternative name: className).
 * @param {Array|HTMLElement} elements - An array of elements or a single element.
 */
function toggleClassOnElements(className, elements) {
    manipulateClassList("toggle").apply(void 0, [className].concat([].slice.call(arguments, 1)));
}

/**
 * a$1 (hasClass)
 *
 * ### **Checks if the specified element has a particular class.**
 * @param {HTMLElement} element - The element to check (alternative name: element).
 * @param {string} className - The class to check for (alternative name: className).
 * @return {boolean} - True if the element has the class; otherwise, false.
 */
function hasClass(element, className) {
    return element.classList.contains(className);
}

// UTILITIES FUNCTIONS

/* ANIMATE LISTS */
/**
 * getMediaQuery takes a querySize parameter and returns the corresponding CSS media query value.
 * If the querySize is invalid, it logs a warning message and returns false.
 *
 * @param {string} querySize - The size of the media query.
 * @returns {string|boolean} - The CSS media query value or false if the querySize is invalid.
 */
function getMediaQuery(querySize) {
    const value = getComputedStyle(document.documentElement).getPropertyValue("--media-".concat(querySize));
    if (!value) {
        console.warn("Invalid querySize passed to getMediaQuery");
        return false;
    }
    return value;
}

/**
 * intersectionWatcher takes a node element and an optional instant flag to determine when the element is intersecting the viewport.
 * If instant is true, the element will be considered intersecting immediately.
 * If instant is false, the element will be considered intersecting when it reaches a certain threshold based on its height.
 *
 * @param {HTMLElement} node - The element to observe for intersection.
 * @param {boolean} [instant=false] - Flag to determine if the element should be considered intersecting immediately.
 * @returns {Object} - An object with a destroy method to disconnect the observer.
 */
const intersectionWatcher = function (node, instant = false) {
    const margin = window.matchMedia(getMediaQuery("above-720")).matches ? 200 : 100;
    let threshold = 0;
    if (!instant) {
        threshold = Math.min(margin / node.offsetHeight, 0.5);
    }
    const observer = new IntersectionObserver(
        (_ref) => {
            let [{ isIntersecting }] = _ref;

            if (isIntersecting) {
                addClassToElements(node, "is-visible");
                observer.disconnect();
            }
        },
        {
            threshold: threshold,
        },
    );
    observer.observe(node);
    return {
        destroy() {
            observer === null || observer === void 0 ? void 0 : observer.disconnect();
        },
    };
};

/**
 * delayOffset takes a node element and an array of selectors and sets the `--delay-offset-multiplier` variable in the correct order.
 * It applies the offset to each item in the selectors array and sets the CSS variable on each item.
 *
 * @param {HTMLElement} node - The section element.
 * @param {Array} items - Array of animation item selectors.
 * @param {number} [offsetStart=0] - The starting offset value.
 */
const delayOffset = function (node, items, offsetStart = 0) {
    let delayOffset = offsetStart;

    items.forEach((selector) => {
        const items = selectElements(selector, node);

        items.forEach((item) => {
            item.style.setProperty("--delay-offset-multiplier", delayOffset);
            delayOffset++;
        });
    });
};

const selectors$1D = {
    sectionBlockItems: ".animation--section-introduction > *",
    controls: ".animation--controls",
    items: ".animation--item",
};
const animateListSlider = (node) => {
    const delayItems = [selectors$1D.sectionBlockItems, selectors$1D.controls, selectors$1D.items];

    // Add the animation delay offset variables
    delayOffset(node, delayItems);

    // In the theme editor, skip the observer and immediately show items
    if (window.Shopify.designMode) {
        addClassToElements(node, "is-visible");
        return { destroy() {} };
    }

    const observer = intersectionWatcher(node);
    return {
        destroy() {
            observer === null || observer === void 0 ? void 0 : observer.destroy();
        },
    };
};

const selectors$11 = {
    animationItem: ".animation--popup-item",
};
const classes$v = {
    animationRevealed: "animation--popup-revealed",
};
/**
 *
 * @param {*} node
 * @returns animating functions open | close
 */
let animatePopup = (node) => {
    delayOffset(node, [selectors$11.animationItem]);

    // Trigger the reveal animation when the drawer is opened
    function open() {
        if (shouldAnimate(node)) {
            addClassToElements(node, classes$v.animationRevealed);
        }
    }

    // Trigger the reveal animation when the drawer is opened
    function close() {
        if (shouldAnimate(node)) {
            removeClassFromElements(node, classes$v.animationRevealed);
        }
    }
    return {
        open,
        close,
    };
};

// END ANIMATE LISTS

/**
 * Carousel
 *
 * ### **Creates a carousel slider with customizable options.**
 * @param {HTMLElement} node - The container element for the carousel slider.
 * @param {object} [options={}] - Optional configuration options for the carousel slider.
 * @return {object} - An object with a destroy method to destroy the carousel slider.
 */
const selectorsCarousel = {
    sliderContainer: ".swiper",
    visibleSlides: ".swiper-slide-visible",
};

const classesCarousel = {
    overflow: "has-overflow",
    carousel: "swiper",
};

const Carousel = function (node) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Pass the swiper container or the contain section
    const swiperContainer = hasClass(node, classesCarousel.carousel)
        ? node
        : selectElement(selectorsCarousel.sliderContainer, node);

    if (!swiperContainer) return;
    let carousel;
    const events = [];
    const nextButton = selectElement("[data-next]", node);
    const prevButton = selectElement("[data-prev]", node);
    const useNav = nextButton && prevButton;

    // Account for additional padding if slides overflow container
    const handleOverflow = (slides) => {
        // Allow breakpoints config settings to apply
        setTimeout(() => {
            const hasOverflow = hasClass(swiperContainer, classesCarousel.overflow);
            const needsOverflow =
                selectElements(selectorsCarousel.visibleSlides, swiperContainer).length !== slides.length;
            if (!hasOverflow && needsOverflow) {
                addClassToElements(swiperContainer, classesCarousel.overflow);
            } else if (hasOverflow && !needsOverflow) {
                removeClassFromElements(swiperContainer, classesCarousel.overflow);
            }
        }, 0);
    };
    const onBreakpointChange = (slides) => {
        handleOverflow(slides);
    };

    function handleFocus(event) {
        const slide = event.target.closest(".swiper-slide");
        if (!slide) return;
        const slideIndex = [...slide.parentElement.children].indexOf(slide);

        if (document.body.classList.contains("user-is-tabbing")) {
            carousel.slideTo(slideIndex);
        }
    }

    import(AF.chunks.swiper).then((_ref) => {
        let { Swiper } = _ref;

        const defaultSwiperOptions = {
            slidesPerView: 2,
            grabCursor: true,
            touchEventsTarget: "container",
            preloadImages: false,
            watchSlidesProgress: true,
            on: {
                init: function () {
                    handleOverflow(this.slides);
                },
                breakpoint: function () {
                    onBreakpointChange(this.slides);
                },
            },
        };

        let swiperOptions = Object.assign(defaultSwiperOptions, options);
        if (useNav) {
            swiperOptions = Object.assign(swiperOptions, {
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
            });
        }

        if ("pagination" in swiperOptions && window.theme.settings.carousel.pagination !== "bullet") {
            swiperOptions.pagination = Object.assign(swiperOptions, {
                pagination: {
                    bulletActiveClass: "swiper-pagination-bullet-active--dash",
                    bulletClass: "swiper-pagination-bullet swiper-pagination-bullet--dash",
                },
            });
        }

        carousel = new Swiper(swiperContainer, swiperOptions);

        events.push(addOrRemoveEventListener(swiperContainer, "focusin", handleFocus));
    });

    return {
        autoplay: {
            start: () => carousel.autoplay.start(),
            stop: () => carousel.autoplay.stop(),
        },
        slideToLoop: (index, speed = 500) => carousel.slideToLoop(index, speed),
        slideTo: (index, speed = 500) => carousel.slideTo(index, speed),
        destroy: () => {
            let _carousel;
            (_carousel = carousel) === null || _carousel === void 0 ? void 0 : _carousel.destroy();
            events.forEach((unsubscribe) => unsubscribe());
        },
    };
};

/**
 * Normalizes localized currency strings into plain numbers.
 * @param {string|number|null|undefined} value
 * @returns {number}
 */
function parseMoneyValue(value) {
    if (value == null) return 0;
    if (typeof value === "number" && !Number.isNaN(value)) return value;
    if (typeof value !== "string") return 0;

    let normalized = value.trim();
    if (!normalized) return 0;

    normalized = normalized.replace(/\s+/g, "");
    const hasComma = normalized.includes(",");
    const hasDot = normalized.includes(".");

    if (hasComma && hasDot) {
        if (normalized.lastIndexOf(".") > normalized.lastIndexOf(",")) {
            normalized = normalized.replace(/,/g, "");
        } else {
            normalized = normalized.replace(/\./g, "").replace(",", ".");
        }
    } else if (hasComma) {
        normalized = normalized.replace(",", ".");
    }

    normalized = normalized.replace(/[^0-9.\-]/g, "");

    const result = Number.parseFloat(normalized);
    return Number.isNaN(result) ? 0 : result;
}

const selectorsFreeShippingProgress = {
    container: ".cart-shipping",
    progressBar: ".cart-shipping__progress-current",
    messageDefault: ".cart-shipping__message_default",
    messageSuccess: ".cart-shipping__message_success",
};

/**
 * Updates the free shipping progress bar based on cart total
 * @param {Document|Element} node - The container node to search within
 * @returns {void}
 */
const FreeShippingProgress = function (node = document) {
    let elements = {
        container: selectElement(selectorsFreeShippingProgress.container, node),
        progressBar: selectElement(selectorsFreeShippingProgress.progressBar, node),
        messageDefault: selectElement(selectorsFreeShippingProgress.messageDefault, node),
        messageSuccess: selectElement(selectorsFreeShippingProgress.messageSuccess, node),
    };

    if (!elements.container || !elements.progressBar) return null;

    const refreshElements = () => {
        console.log("Refreshing free shipping progress elements");
        elements.container = selectElement(selectorsFreeShippingProgress.container, node);
        elements.progressBar = selectElement(selectorsFreeShippingProgress.progressBar, elements.container);
        elements.messageDefault = selectElement(selectorsFreeShippingProgress.messageDefault, elements.container);
        elements.messageSuccess = selectElement(selectorsFreeShippingProgress.messageSuccess, elements.container);
    };

    try {
        const previousProgress = getComputedStyle(elements.progressBar).getPropertyValue("width");
        document.documentElement.style.setProperty("--progress-prev", previousProgress);
    } catch (error) {
        // Silent failure – animations simply start from zero.
        console.log("Error getting previous progress:", error);
    }

    const state = {
        currencyFormatter: null,
    };

    const getCurrencyFormatter = () => {
        if (state.currencyFormatter) return state.currencyFormatter;

        const locale = (window.Shopify && window.Shopify.locale) || document.documentElement.lang || "en";
        const currency =
            (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ||
            (window.theme && window.theme.settings && window.theme.settings.currency) ||
            "USD";

        try {
            state.currencyFormatter = new Intl.NumberFormat(locale.replace("_", "-"), {
                style: "currency",
                currency,
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
        } catch (formatError) {
            state.currencyFormatter = null;
        }

        return state.currencyFormatter;
    };

    const formatCurrency = (amount) => {
        const formatter = getCurrencyFormatter();
        if (!formatter) {
            return amount.toFixed(2);
        }

        return formatter.format(amount);
    };

    const toggleMessageVisibility = (isQualified, remainingAmount) => {
        if (elements.messageDefault) {
            if (isQualified) {
                elements.messageDefault.classList.remove("active");
            } else {
                const template = elements.container.dataset.message || "";
                const replacement = template.includes("||amount||")
                    ? template.replace("||amount||", formatCurrency(remainingAmount))
                    : `${template} ${formatCurrency(remainingAmount)}`;

                elements.messageDefault.innerHTML = replacement;
                elements.messageDefault.classList.add("active");
            }
        }

        if (elements.messageSuccess) {
            elements.messageSuccess.classList.toggle("active", isQualified);
        }
    };

    const updateFreeShippingProgress = (rawCartTotal) => {
        refreshElements();

        const cartTotal = parseMoneyValue(rawCartTotal);
        const minSpendAmount = parseMoneyValue(elements.container.dataset.minSpend);

        if (!elements.progressBar) {
            toggleMessageVisibility(false, minSpendAmount);
            return cartTotal;
        }

        if (minSpendAmount <= 0) {
            elements.progressBar.style.width = "0%";
            elements.progressBar.style.setProperty("--progress-prev", "0%");
            toggleMessageVisibility(false, 0);
            return cartTotal;
        }

        const progress = Math.min((cartTotal / minSpendAmount) * 100, 100);
        const progressValue = `${progress}%`;

        elements.progressBar.style.width = progressValue;
        elements.progressBar.style.setProperty("--progress-prev", progressValue);
        elements.container.dataset.total = `${cartTotal}`;

        const remainingAmount = Math.max(minSpendAmount - cartTotal, 0);
        const isQualified = remainingAmount <= 0.0001;

        toggleMessageVisibility(isQualified, remainingAmount);
        return cartTotal;
    };

    const init = () => {
        return cart
            .get()
            .then((cartData) => {
                const cartTotal = cartData && typeof cartData.total_price === "number" ? cartData.total_price / 100 : 0;
                return updateFreeShippingProgress(cartTotal);
            })
            .catch((error) => {
                console.error("Error initializing free shipping progress", error);
                return 0;
            });
    };

    return {
        containerElement: elements.container,
        init,
        update: updateFreeShippingProgress,
    };
};
// INITIALEZE REGISTERED SECTIONS
/**
 *
 * Object containing the registered section types names.
 * this is primarily used to identify the type of section being loaded.
 * CTRL + click on the section type to see the registered section code.
 *
 */
const sectionTypes = {
    announcementMarquee: "announcement-marquee",
    featuredCollectionSlider: "featured-collection-slider",
    relatedProducts: "product-recommendations-slider",
    mainSearch: "search",
    mainCollection: "collection",
    mainProduct: "main-product",
    mainCart: "main-cart",
    cartDrawer: "cart-drawer",
    header: {
        gigaMenu: "giga-menu",
        newNavDrawer: "new-nav-drawer",
    },
    categorySliderBanner: "category-slider-banner",
    productCarouselBanner: "product-carousel-banner",
    mediaSwper: "media-swiper",
    countdown: {
        banner: "countdown-banner",
        product: "countdown-product",
    },
    popup: "popup-overlay",
    footer: "footer",
    videoBanner: "video-banner",
    sizeGuide: "size_guide",
    storySlider: "story-slider",
};

const routes = window.routes.cart || {};
const paths = {
    base: "".concat(routes.base || "/cart", ".js"),
    add: "".concat(routes.add || "/cart/add", ".js"),
    change: "".concat(routes.change || "/cart/change", ".js"),
    clear: "".concat(routes.clear || "/cart/clear", ".js"),
    update: "".concat(routes.update || "/cart/update", ".js"),
};

const {
    strings: { cart: cartStrings },
} = window.theme;
const cart = {
    /**
     * Sorts the items in the cart based on a predefined order.
     * If a custom order is not defined, the items remain unsorted.
     *
     * @param {Object} cart - The cart object containing the items to be sorted.
     * @returns {Object} - The cart object with the sorted items.
     */
    sortCart(cart) {
        const order = getStorage("cart_order") || [];
        if (order.length) {
            cart.sorted = [...cart.items].sort((a, b) => order.indexOf(a.variant_id) - order.indexOf(b.variant_id));
            return cart;
        }
        cart.sorted = cart.items;
        return cart;
    },
    /**
     * Retrieves data from the server using a GET request.
     * @returns {Promise} A promise that resolves to the sorted data.
     */
    async get() {
        return fetch(paths.base, {
            method: "GET",
            credentials: "include",
        })
            .then((res) => res.json())
            .then((data) => {
                const sortedData = this.sortCart(data);
                return sortedData;
            });
    },
    /**
     * Updates the quantity of an item in the Shopify cart.
     * @param {string} key - The unique key of the item to be updated.
     * @param {number} quantity - The new quantity of the item.
     * @returns {Promise} - A promise that resolves when the item is successfully updated.
     */
    async updateItem(key, quantity) {
        return this.get().then(({ items }) => {
            for (let i = 0; i < items.length; i++) {
                if (items[i].key === key) {
                    return this.changeItem(i + 1, key, quantity); // shopify cart is a 1-based index
                }
            }
        });
    },
    /**
     * Adds an item to the cart.
     * @param {HTMLFormElement} form - The form containing the item details.
     * @returns {Promise<Object>} A promise that resolves to an object containing the added item and the updated cart.
     */
    async addItem(form) {
        triggerEvent("cart:updating");

        return fetch(paths.add, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                "X-Requested-With": "XMLHttpRequest",
            },
            body: serialize(form),
        })
            .then((r) => r.json())
            .then(async (res) => {
                if (res.status == "422") {
                    const error = {
                        code: 422,
                        message: res.description,
                    };
                    this.handleError(error, "addItem", null);
                }
                return this.get().then((cart) => {
                    const order = getStorage("cart_order") || [];
                    const newOrder = [res.variant_id, ...order.filter((i) => i !== res.variant_id)];
                    setStorage("cart_order", JSON.stringify(newOrder));
                    triggerEvent("cart:updated", {
                        cart: this.sortCart(cart),
                    });
                    triggerEvent("quick-cart:updated");
                    dispatchCustomEvent("cart:updated", {
                        cart: this.sortCart(cart),
                    });
                    return {
                        item: res,
                        cart: this.sortCart(cart),
                    };
                });
            });
    },
    /**
     * Adds an item to the cart by its ID and quantity.
     * @param {string} id - The ID of the item to add.
     * @param {number} quantity - The quantity of the item to add.
     * @returns {Promise<Object>} A promise that resolves to an object containing the response and the updated cart.
     */
    async addItemById(id, quantity) {
        triggerEvent("cart:updating");
        let data = {
            items: [
                {
                    id,
                    quantity,
                },
            ],
        };
        return fetch(paths.add, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((r) => r.json())
            .then(async (res) => {
                if (res.status == "422") {
                    const error = {
                        code: 422,
                        message: res.description,
                    };
                    this.handleError(error, "addItemById", id);
                }
                return this.get().then((cart) => {
                    triggerEvent("quick-cart:updated");
                    triggerEvent("cart:updated", {
                        cart,
                    });
                    return {
                        res,
                        cart,
                    };
                });
            });
    },
    /**
     * Changes the quantity of an item in the cart.
     * @param {number} line - The line number of the item in the cart.
     * @param {string} itemKey - The key of the item.
     * @param {number} quantity - The new quantity of the item.
     * @returns {Promise<Object>} A promise that resolves to the updated cart object.
     */
    async changeItem(line, itemKey, quantity) {
        return fetch(paths.change, {
            method: "POST",
            credentials: "include",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                line,
                quantity,
            }),
        })
            .then((res) => {
                if (res.status == "422") {
                    const error = {
                        code: 422,
                        message: cartStrings.quantityError,
                    };
                    this.handleError(error, "changeItem", itemKey);
                } else {
                    return res.json();
                }
            })
            .then((cart) => {
                triggerEvent("cart:updated", {
                    cart,
                });
                triggerEvent("quick-cart:updated");
                return this.sortCart(cart);
            });
    },
    /**
     * Handles errors that occur during cart operations.
     *
     * @param {Error} error - The error object.
     * @param {string} source - The source of the error.
     * @param {string} itemKeyOrId - The key or ID of the item associated with the error.
     * @throws {Error} - The original error object.
     */
    handleError(error, source, itemKeyOrId) {
        if (source === "changeItem") {
            triggerEvent("quick-cart:error", null, {
                key: itemKeyOrId,
                errorMessage: cartStrings.quantityError,
            });
            triggerEvent("cart:error", null, {
                key: itemKeyOrId,
                errorMessage: cartStrings.quantityError,
            });
        } else if (source === "addItemById") {
            triggerEvent("quick-add:error", null, {
                id: itemKeyOrId,
                errorMessage: cartStrings.quantityError,
            });
        }
        throw error;
    },
};

const selectors$v = {
    item: "[data-input-item]",
    itemProperties: "[data-item-properties]",
    quantityInput: "[data-quantity-input]",
    quantityAdd: "[data-add-quantity]",
    quantitySubtract: "[data-subtract-quantity]",
    removeItem: "[data-remove-item]",
};

function QuantityButtons(node) {
    const delegate = new Delegate(node);
    function disableWhileLoad(item, target) {
        selectElement(".loading-spinner-wrapper", item) &&
            removeClassFromElements(selectElement(".loading-spinner-wrapper", item), "hidden");
        selectElements("button, input", item) && addClassToElements(selectElements("button, input", item), "disabled");
    }

    delegate.on("click", selectors$v.quantitySubtract, (_, target) => {
        const item = target.closest(selectors$v.item);
        disableWhileLoad(item, target);
        const { key } = item.dataset;

        const qty = selectElement(selectors$v.quantityInput, item).value;

        triggerEvent("quantity-update:subtract", null, {
            key,
        });
        cart.updateItem(key, parseInt(qty) - 1);
        selectElement(selectors$v.quantityInput, item).value = parseInt(qty) - 1;
    });

    delegate.on("click", selectors$v.quantityAdd, (_, target) => {
        const item = target.closest(selectors$v.item);
        disableWhileLoad(item, target);

        const { key } = item.dataset;

        const qty = selectElement(selectors$v.quantityInput, item).value;
        triggerEvent("quantity-update:add", null, {
            key,
        });

        cart.updateItem(key, parseInt(qty) + 1);
    });

    delegate.on("click", selectors$v.removeItem, (_, target) => {
        const item = target.closest(selectors$v.item);
        disableWhileLoad(item, target);
        const { key } = item.dataset;
        triggerEvent("quantity-update:remove", null, {
            key,
        });
        cart.updateItem(key, 0);
    });

    const unload = () => {
        delegate.off();
    };

    return {
        unload,
    };
}
function addDiscount(container) {
    const selectors = {
        codeInput: "#discount-code-input",
        applyDiscount: "[apply-discount-btn]",
        discountCodeWrapper: "#discount-codes-wrapper",
        cartTotal: ".cart__footer-subtotal .price.price--end",
        discountCodeError: "#discount-code-error",
        loadingWrapperApply: "[apply-discount-btn].button .loading_spinner_wrapper",
        loadingWrapperRemove: "[data-clear-discount-btn] + .loading_spinner_wrapper",
        remDiscount: "[data-clear-discount-btn]",
    };
    const elements = {
        discountCodeWrapper: selectElement(selectors.discountCodeWrapper, container),
        totalCartSelector: selectElement(selectors.cartTotal, container),
        discountCodeError: selectElement(selectors.discountCodeError, container),
        loadingWrapperApply: selectElement(selectors.loadingWrapperApply, container),
    };
    const errorMessages = {
        discountCodeEmpty: window.theme.strings.cart.discountCodeEmpty,
        discountCodeApplied: window.theme.strings.cart.discountCodeApplied,
        discountCodeInvalid: window.theme.strings.cart.discountCodeInvalid,
        cantRemoveDiscount: window.theme.strings.cart.cantRemoveDiscount,
    };

    const delegate = new Delegate(container);

    delegate.on("load", (_, target) => {
        // if(hasStorage(localStorageKey)) removeStorage(localStorageKey);

        // get discounts from cart
        let discountsAdded = selectElement("[data-manual-discounts]", target).dataset.manualDiscounts
            ? selectElement("[data-manual-discounts]", target).dataset.manualDiscounts.split(",")
            : "";

        //if discounts already exists or there are no discounts return
        if (discountsAdded === "" || discountsAdded.some((disc) => disc.includes(getStorage(localStorageKey)?.codes)))
            return;

        // if there are any discounts
        if (discountsAdded) {
            console.log("LOAD -> discountExists  ", discountsAdded);

            discountsAdded = discountsAdded.filter(function (item) {
                return item.trim() !== "";
            });

            console.log("LOAD -> discount filtered ", discountsAdded);

            setStorage(localStorageKey, JSON.stringify({ codes: discountsAdded }));
            return;
        }
    });

    delegate.on("click", selectors.remDiscount, (_, target) => {
        let codeToRemove = target.dataset.clearDiscountBtn;
        if (!codeToRemove) return _handleDiscountError(errorMessages.cantRemoveDiscount);

        _clearDiscount(codeToRemove, target, container);
    });

    delegate.on("click", selectors.applyDiscount, (_, target) => {
        let code = selectElement(selectors.codeInput, container).value;
        code = code.trim();
        console.log("INPUT CODE => ", code);
        _applyDiscount(code);
    });

    delegate.on("keydown", selectors.codeInput, (event, target) => {
        if (event.key === "Enter") {
            let code = target.value;
            code = code.trim().toUpperCase();
            _applyDiscount(code);
        }
    });

    const localStorageKey = "discount_code";

    /**
     * Applies a discount code to the checkout process.
     *
     * @param {string} code - The discount code to apply.
     * @returns {void}
     */
    const _applyDiscount = (code) => {
        //if there was mo code entered return error
        if (!code) return _handleDiscountError(errorMessages.discountCodeEmpty);

        // if the code was already inserted return error
        // if(selectElement(`[data-clear-discount-btn="${code}"]`, document) && selectElement('[data-manual-discounts]', document).dataset.manualDiscounts.includes(code) ) return _handleDiscountError(errorMessages.discountCodeApplied);

        let allDiscountsCodes = _getStorageDiscounts(code);

        const __createDiscountEl = (newCodeEl, spinnerEl, newContainer) => {
            let discountEl = document.createElement("div");
            discountEl.classList.add("applied-discount-code-wrapper");
            discountEl.dataset.code = code;
            discountEl.innerHTML = newCodeEl;
            let btn = document.createElement("button");
            btn.type = "button";
            btn.dataset.clearDiscountBtn = code;
            btn.innerText = "X";
            btn.addEventListener("click", _clearDiscount.bind(code, btn, newContainer));

            discountEl.appendChild(btn);
            discountEl.insertAdjacentHTML("beforeEnd", spinnerEl);
            return discountEl;
        };

        // start loading spinner
        elements.loadingWrapperApply && removeClassFromElements(elements.loadingWrapperApply, "hidden");

        let hasErrors = false;

        // call checkout URL with the discounts parameter
        fetch(`/checkout?discount=${allDiscountsCodes}`)
            .then(async () => {
                //get cart after call
                const dataCart = await fetch(`/cart?section_id=${container.dataset.sectionId}`).then((response) =>
                    response.text(),
                );
                //parse it to a variable
                const newCart = new DOMParser().parseFromString(dataCart, "text/html");

                // check if discount is already in cart
                _checkifDiscountIs(
                    newCart,
                    code,
                    () => {
                        // add the chip with the code
                        elements.discountCodeWrapper.append(
                            __createDiscountEl(
                                selectElement(".applied-discount-code-value", newCart).outerHTML,
                                selectElement(".loading_spinner_wrapper", newCart).outerHTML,
                                newCart,
                            ),
                        );

                        //replace the cart with the new one
                        selectElement(".cart__form-items", container).outerHTML = selectElement(
                            ".cart__form-items",
                            newCart,
                        ).outerHTML;

                        //replace the total with the new one
                        selectElement("[footer-cart-refresh]", container).outerHTML = selectElement(
                            "[footer-cart-refresh]",
                            newCart,
                        ).outerHTML;

                        //clear the input
                        selectElement(selectors.codeInput, container).value = "";

                        //clear errors
                        _handleDiscountError("");

                        // stop loading spinner
                        addClassToElements(elements.loadingWrapperApply, "hidden");

                        // set local storage with the code
                        _setStorageDiscount(code);
                    },
                    () => {
                        // if the code is invalid return error
                        _handleDiscountError(errorMessages.discountCodeInvalid);
                        addClassToElements(elements.loadingWrapperApply, "hidden");
                        hasErrors = true;
                    },
                );
            })
            .then(() => {
                if (!hasErrors) window.location.reload();
            })
            .catch((err) => console.error("Calling checkout gives error =>", err));
    };

    const _clearDiscount = async (code, target, newContainer) => {
        // add loading icon
        selectElement(selectors.loadingWrapperRemove, target.parentElement) &&
            removeClassFromElements(selectElement(selectors.loadingWrapperRemove, target.parentElement), "hidden");

        // remove discount code from local storage
        _removeStorageDiscount(code);

        let storage = getStorage(localStorageKey)?.codes;
        let discountsAddedToCart = selectElement("[data-manual-discounts]", newContainer).dataset.manualDiscounts;
        let allDiscountsCodes = storage ? storage.join(",") : "''";

        fetch(`/checkout?discount=${allDiscountsCodes}`).then(async () => {
            const oldCart = await fetch(`/cart?section_id=${newContainer.dataset.sectionId}`).then((response) =>
                response.text(),
            );
            const newCart = new DOMParser().parseFromString(oldCart, "text/html");

            discountsAddedToCart = discountsAddedToCart.replace(`,${code}`, "");

            newContainer.dataset.manualDiscounts = discountsAddedToCart;

            selectElement("[footer-cart-refresh]", newContainer).outerHTML = selectElement(
                "[footer-cart-refresh]",
                newCart,
            ).outerHTML;
            selectElement(".cart__form-items", newContainer).outerHTML = selectElement(
                ".cart__form-items",
                newCart,
            ).outerHTML;

            target.parentElement && target.parentElement.remove();
        });
    };

    /**
     * Sets the storage with the provided discount code.
     * If the code is already in the storage, it returns an error.
     *
     * @param {string} code - The discount code to be stored.
     * @returns {void}
     */
    const _setStorageDiscount = (code) => {
        //if there is no code entered set storage with the actual code
        if (!hasStorage(localStorageKey)) return setStorage(localStorageKey, JSON.stringify({ codes: [code] }));

        //if there is a code entered push the new code to the storage
        let storageDiscounts = getStorage(localStorageKey);

        //if the code is already in the storage return error
        for (const discount in storageDiscounts?.codes) {
            let storageDiscount = storageDiscounts.codes[discount].trim().toUpperCase();
            if (storageDiscount === code) return _handleDiscountError(errorMessages.discountCodeApplied);
        }

        storageDiscounts.codes.push(code.trim().toUpperCase());
        // and save it to local
        return setStorage(localStorageKey, JSON.stringify(storageDiscounts));
    };
    /**
     * Retrieves the storage discounts and concatenates them with the provided code.
     *
     * @param {string} code - The discount code to be concatenated with the storage discounts.
     * @returns {string} - The concatenated string of all discounts codes, including the provided code.
     */
    const _getStorageDiscounts = (code) => {
        // if there is no storage return the code
        if (!hasStorage(localStorageKey)) return code;
        let storageDiscounts = getStorage(localStorageKey);
        let allDiscountsCodes = "";

        // populate the allDiscountsCodes with the storage discounts
        for (const discount in storageDiscounts?.codes) {
            allDiscountsCodes
                ? (allDiscountsCodes = allDiscountsCodes.concat(
                      "," + storageDiscounts.codes[discount].trim().toUpperCase(),
                  ))
                : (allDiscountsCodes = storageDiscounts.codes[discount].trim().toUpperCase());
        }
        // if the code is already in the storage return the storage discounts
        return allDiscountsCodes.concat("," + code);
    };

    /**
     * Removes a discount code from the storage.
     *
     * @param {string} code - The discount code to be removed.
     * @returns {void}
     */
    const _removeStorageDiscount = (code) => {
        // if there is no storage return
        if (!hasStorage(localStorageKey)) return;

        let storageDiscounts = getStorage(localStorageKey);
        // if the code is not in the storage return
        if (!storageDiscounts.codes.includes(code)) return;
        // if there is only one code in the storage remove the storage
        if (storageDiscounts.codes.length === 1) return removeStorage(localStorageKey);
        // if there are more than one code in the storage remove the code from the storage
        let newStorageDiscounts = storageDiscounts.codes.filter((discount) => discount !== code);
        setStorage(localStorageKey, JSON.stringify({ codes: newStorageDiscounts }));
        return;
    };

    /**
     * Checks if a discount code is applied to the cart.
     *
     * @param {number} state - The state of the cart. Default is 1. 0 means remove discount, 1 means apply discount.
     * @param {Element} newCart - The new cart element.
     * @param {string} code - The discount code to check.
     * @param {Function} codeExistsCallBack - The callback function to execute if the code exists.
     * @param {Function} codeDoesNotExistCallBack - The callback function to execute if the code does not exist.
     * @returns {any} - The result of the callback function.
     */
    const _checkifDiscountIs = (newCart, code, codeExistsCallBack = () => {}, codeDoesNotExistCallBack = () => {}) => {
        // check if the discount code is already applied
        let discountsAdded = selectElement("[data-manual-discounts]", newCart).dataset.manualDiscounts.split(",");
        let allDiscounts = selectElements("[data-clear-discount-btn]", elements.discountCodeWrapper).forEach(
            (el) => el.dataset.clearDiscountBtn,
        );

        console.log("allDiscounts: ", allDiscounts);

        if (discountsAdded.some((discount) => discount === code)) {
            return codeExistsCallBack();
        } else {
            return codeDoesNotExistCallBack();
        }
    };

    const _handleDiscountError = (message = "") => {
        if (message === "") return (elements.discountCodeError.innerHTML = "");

        if (elements.discountCodeError) elements.discountCodeError.innerHTML = message;
    };

    const unload = () => {
        delegate.off();
    };
    return {
        unload,
    };
}

const selectors$3 = {
    cartError: ".cart__form-item-error",
    cartUpdateButton: ".cart__update",
    cartItems: ".cart__form-items",
    cartTotal: ".cart__footer-subtotal",
    quantityInput: ".cart .quantity-input__input",
    quantityItemInput: "[data-input-item]",
    quantityElement: "[data-quantity-element]",
    loadingWrapper: ".cart__form-items .loading-spinner-wrapper",
    cartBubbleCount: ".cart-count-bubble",
};
const classes$5 = {
    updatingQuantity: "disabled",
    removed: "is-removing",
    hidden: "hidden",
};
register(sectionTypes.mainCart, {
    onLoad() {
        this.quantityButtons = QuantityButtons(this.container);
        this.cartBubbleCount = selectElements(selectors$3.cartBubbleCount, document);
        addDiscount(this.container);

        // Events are all on events trigger by other components / functions
        this.events = [
            registerListener("cart:updated", (_, _ref) => {
                this.refreshCart();
            }),
            registerListener("cart:error", (_, { key, errorMessage }) => this.handleErrorMessage(key, errorMessage)),
            registerListener(["quantity-update:subtract", "quantity-update:add"], (_, { key }) =>
                this.handleQuantityUpdate(key),
            ),
            registerListener("quantity-update:remove", (_, { key }) => this.handleItemRemoval(key)),
        ];

        // Delegate handles all click events due to rendering different content within cart
        this.delegate = new Delegate(this.container);
        this.delegate.on("change", selectors$3.quantityInput, (e) => this.handleQuantityInputChange(e));
    },

    refreshCart() {
        const url = "".concat(window.routes.cart.cart_url, "?section_id=main-cart");

        makeRequest("GET", url).then((response) => {
            let _window$Shopify;
            let container = document.createElement("div");
            container.innerHTML = response;

            if (selectElement(selectors$3.cartItems, container) && selectElement(selectors$3.cartTotal, container)) {
                updateInnerHTML(selectors$3.cartItems, container);
                updateInnerHTML(selectors$3.cartTotal, container);
            } else {
                this.container.innerHTML = container.innerHTML;
            }

            const itemsCount = selectElement(".cart__form-item-count", container)
                ? selectElement(".cart__form-item-count", container).textContent.match(/(\d+)/)[0]
                : 0;
            this.cartBubbleCount.forEach((bubble) => {
                if (itemsCount === 0) return (bubble.innerHTML = "");

                bubble.textContent = itemsCount;
            });

            if (
                (_window$Shopify = window.Shopify) !== null &&
                _window$Shopify !== void 0 &&
                _window$Shopify.StorefrontExpressButtons
            ) {
                window.Shopify.StorefrontExpressButtons.initialize();
            }
        });
    },

    /**
     * Enables or disables buttons and inputs within a given element.
     *
     * @param {HTMLElement} item - The element containing the buttons and inputs.
     * @param {string} action - The action to perform. Must be either 'disable' or 'enable'.
     */
    _enableDisableButtons(item, action) {
        const buttons = selectElements("button, input", item);
        if (action === "disable") {
            selectElement(".loading-spinner-wrapper", item) &&
                removeClassFromElements(selectElement(".loading-spinner-wrapper", item), classes$5.hidden);
            buttons.forEach((button) => addClassToElements(button, "disabled"));
            addClassToElements(selectElement(selectors$3.cartError, item), classes$5.hidden);
            addClassToElements(item, classes$5.updatingQuantity);
        } else {
            selectElement(".loading-spinner-wrapper", item) &&
                addClassToElements(selectElement(".loading-spinner-wrapper", item), classes$5.hidden);
            buttons.forEach((button) => removeClassFromElements(button, "disabled"));
            removeClassFromElements(selectElement(selectors$3.cartError, item), classes$5.hidden);
            removeClassFromElements(item, classes$5.updatingQuantity);
        }
    },

    handleErrorMessage(key) {
        const item = selectElement('[data-key="'.concat(key, '"]'), this.container);

        this._enableDisableButtons(item, "enable");
    },

    handleQuantityInputChange({ target }) {
        const item = target.closest(selectors$3.quantityItemInput);

        const { key } = item.dataset;

        cart.updateItem(key, target.value);
        this.handleQuantityUpdate(key);
    },

    handleQuantityUpdate(key) {
        const item = selectElement('[data-key="'.concat(key, '"]'), this.container);
        this._enableDisableButtons(item, "disable");
    },

    handleItemRemoval(key) {
        const item = selectElement('[data-key="'.concat(key, '"]'), this.container);
        addClassToElements(item, classes$5.removed);
        this._enableDisableButtons(item, "disable");
    },
    onUnload() {
        let _this$cartNoteToggle;
        this.events.forEach((unsubscribe) => unsubscribe());
        this.quantityButtons.unload();
        (_this$cartNoteToggle = this.cartNoteToggle) === null || _this$cartNoteToggle === void 0
            ? void 0
            : _this$cartNoteToggle.unload();
    },
});

const selectors$s = {
    cartWrapper: ".cart-drawer",
    item: "[data-input-item]",
    quantityItemInput: "[data-quantity-input]",
    innerContainer: "cart-drawer:has(#CartDrawer)",
    quantityInput: ".cart-drawer .quantity-input__input",
    items: ".cart-items tbody",
    subtotal: ".cart-drawer__footer .totals__total-value",
    cartBubbleCount: ".cart-count-bubble",
    cartError: ".cart__form-item-error",
    cartDrawerTag: "cart-drawer",
};
const classes$c = {
    active: "active",
    hidden: "hidden",
    updatingQuantity: "disabled",
    removed: "is-removing",
    empty: "is-empty",
};
register(sectionTypes.cartDrawer, {
    onLoad() {
        this.quantityButtons = QuantityButtons(this.container);

        this.cartWrapper = selectElement(selectors$s.cartWrapper, this.container);
        this.bubbleCount = selectElements(selectors$s.cartBubbleCount, document);
        this.freeShipping = {
            active: this.container.dataset.cartFreeShippingActive === "true",
            threshold: parseMoneyValue(this.container.dataset.cartFreeShippingThreshold),
        };
        this.cartShipping = this.freeShipping.active ? FreeShippingProgress(this.container) : null;

        // Troppo lento all'update del cartDrawer - Trovato dentro cart-drawer.js - funzione open
        // document.addEventListener("transitionend", (_, _ref) => this.refreshQuickCart());

        this.events = [
            registerListener("quick-cart:updated", () => this.refreshQuickCart()),
            registerListener("quick-cart:error", (_, { key, errorMessage }) =>
                this.handleErrorMessage(key, errorMessage),
            ),
            registerListener("quantity-update:remove", (_, { key }) => this.handleItemRemoval(key)),
        ];

        this.delegate = new Delegate(this.container);
        this.delegate.on("change", selectors$s.quantityInput, (e) => this.handleQuantityInputChange(e));
        this.delegate;

        if (this.freeShipping.active) {
            const initialTotal = parseMoneyValue(this.container.dataset.cartTotalPrice);
            this._updateFreeShipping(initialTotal);

            if (this.cartShipping && typeof this.cartShipping.init === "function") {
                this.cartShipping.init().then((total) => {
                    if (typeof total === "number") {
                        this._updateFreeShipping(total);
                    }
                });
            }
            window.FreeShippingProgress = FreeShippingProgress;
        }
    },
    refreshQuickCart() {
        const url = "".concat(`?section_id=${this.id}`);

        makeRequest("GET", url).then((response) => {
            let container = document.createElement("div");
            container.innerHTML = response;

            const responseInnerContainer = selectElement(".drawer__inner", container);
            const responseHasItems = Boolean(selectElement(selectors$s.items, container));
            const cartHasItems = Boolean(selectElement(selectors$s.items, this.container));

            // Cart has items and needs to update them
            if (responseHasItems && cartHasItems) {
                // Render cart items
                updateInnerHTML("".concat(selectors$s.cartWrapper, " ").concat(selectors$s.items), container);
                // Render subtotal
                updateInnerHTML("".concat(selectors$s.cartWrapper, " ").concat(selectors$s.subtotal), container);

                const latestDrawer = selectElement(selectors$s.cartDrawerTag, container);
                const latestTotal = latestDrawer ? parseMoneyValue(latestDrawer.dataset.cartTotalPrice) : 0;
                const latestThreshold = latestDrawer
                    ? parseMoneyValue(latestDrawer.dataset.cartFreeShippingThreshold)
                    : this.freeShipping.threshold;

                this.freeShipping.threshold = latestThreshold;
                this.container.dataset.cartTotalPrice = `${latestTotal}`;
                this.container.dataset.cartFreeShippingThreshold = `${latestThreshold}`;
                this._updateFreeShipping(latestTotal);

                // MODIFICA FATTA CUSTOM DI MURPHY PER ATTIVARE IL FREESHIPPING
                // PROGRESS BAR SOLO DOPO UNA DETERMINATA SOGLIA DI SPESA
                if (latestThreshold && latestTotal) {
                    const threshold = parseFloat(latestThreshold);
                    const totalPrice = parseFloat(latestTotal);

                    if (totalPrice >= threshold) {
                        this.cartShipping.containerElement &&
                            removeClassFromElements(this.cartShipping.containerElement, classes$c.hidden);
                    } else {
                        this.cartShipping.containerElement &&
                            addClassToElements(this.cartShipping.containerElement, classes$c.hidden);
                    }
                }
                /*
          QUESTO BLOCCO DI COIDCE STA QUI PER FAR FUNZIONARE L'ELLIMINAZIONE DELL'ITEM NEL DRAWER
          SI PUÓ MODIFICARE AGGIUSTANDO LA RIGA 2544
        */
                // inizializza il numero totale dei prodotti a 0 (contatore)
                let totalQuantity = 0;

                // Seleziona gli input delle quantità dal contenitore aggiornato
                const cartItems = selectElements(selectors$s.item, container);

                cartItems.forEach((item) => {
                    totalQuantity += parseInt(item.dataset.cartItemQuantity || "0", 10); // Somma le quantità
                });

                let cartCounters = selectElements(selectors$s.cartBubbleCount, document);

                // Aggiorna il valore della bolla del carrello con il totale
                cartCounters.forEach((bubble) => {
                    bubble.innerHTML = totalQuantity > 0 ? totalQuantity : ""; // Mostra il totale o svuota se 0
                });
                /* BLOCCO CODICE FINISCHE QUI */
            } else {
                // Cart is empty needs to be replaced by the fetch response
                selectElement(".drawer__inner", this.container).innerHTML = responseInnerContainer.innerHTML;
                addClassToElements(this.container, classes$c.empty);

                selectElements(selectors$s.cartBubbleCount, document).forEach((bubble) => {
                    bubble.innerHTML = "0";
                });

                this._updateFreeShipping(0);
            }
        });
    },

    /**
     * Enables or disables buttons and inputs within a given element.
     *
     * @param {HTMLElement} item - The element containing the buttons and inputs.
     * @param {string} action - The action to perform. Must be either 'disable' or 'enable'.
     */
    _enableDisableButtons(item, action) {
        const buttons = selectElements("button, input", item);
        if (action === "disable") {
            selectElement(".loading-spinner-wrapper", item) &&
                removeClassFromElements(selectElement(".loading-spinner-wrapper", item), classes$5.hidden);
            buttons.forEach((button) => addClassToElements(button, "disabled"));
            selectElement(selectors$s.cartError, item) &&
                addClassToElements(selectElement(selectors$s.cartError, item), classes$c.hidden);
            addClassToElements(item, classes$c.updatingQuantity);
        } else {
            selectElement(".loading-spinner-wrapper", item) &&
                addClassToElements(selectElement(".loading-spinner-wrapper", item), classes$5.hidden);
            buttons.forEach((button) => removeClassFromElements(button, "disabled"));
            selectElement(selectors$s.cartError, item) &&
                removeClassFromElements(selectElement(selectors$s.cartError, item), classes$c.hidden);
            removeClassFromElements(item, classes$c.updatingQuantity);
        }
    },

    handleErrorMessage(key) {
        const item = selectElement('[data-key="'.concat(key, '"]'), this.container);

        this._enableDisableButtons(item, "enable");
    },
    handleQuantityUpdate(key) {
        const item = selectElement('[data-key="'.concat(key, '"]'), this.container);

        addClassToElements(item, classes$c.updatingQuantity);
    },
    handleQuantityInputChange({ target }) {
        const item = target.closest(selectors$s.quantityItemInput);

        const { key } = item.dataset;

        cart.updateItem(key, target.value);

        this.handleQuantityUpdate(key);
    },
    handleItemRemoval(key) {
        const item = selectElement('[data-key="'.concat(key, '"]'), this.container);
        addClassToElements(item, classes$c.removed);
        addClassToElements(item, classes$c.updatingQuantity);
    },
    _updateFreeShipping(cartTotal) {
        if (!this.freeShipping || !this.freeShipping.active) return;

        if (!this.cartShipping) {
            this.cartShipping = FreeShippingProgress(this.container);
        }

        if (!this.cartShipping || typeof this.cartShipping.update !== "function") return;

        const updatedTotal = this.cartShipping.update(cartTotal);
        const effectiveTotal =
            typeof updatedTotal === "number" && !Number.isNaN(updatedTotal) ? updatedTotal : parseMoneyValue(cartTotal);

        if (this.cartShipping.containerElement) {
            const shouldHide = this.freeShipping.threshold > 0 && effectiveTotal < this.freeShipping.threshold;
            this.cartShipping.containerElement.classList.toggle(classes$c.hidden, shouldHide);
        }
    },
    onUnload() {
        this.quantityButtons.unload();
    },
});

// Sticky add to cart bar function
function stickyAtcBar(container, variants) {
    const classes = {
        hidden: "hidden",
    };
    const selectors = {
        buyButtons: ".product-form__submit",
        pageFooter: "footer",
        stickyAtcBar: ".sticky-atc-bar",
        variantSelector: '[data-variants-type="size"] .product__variant',
        optionValues: "option",
    };
    const elements = {
        buyButtons: selectElement(selectors.buyButtons, container),
        pageFooter: selectElement(selectors.pageFooter, document),
        stickyAtcBar: selectElement(selectors.stickyAtcBar, container),
    };

    // If the sticky ATC bar is not present, return early
    if (elements.stickyAtcBar == null) return;

    // Select the rest of the elements when the sticky ATC bar is present
    elements.variantSelector = selectElement(selectors.variantSelector, elements.stickyAtcBar);
    elements.optionValues = elements.variantSelector
        ? selectElements(selectors.optionValues, elements.variantSelector)
        : [];

    const events = [];

    if (elements.variantSelector) {
        events.push(
            addOrRemoveEventListener(elements.variantSelector, "change", (event) => {
                const optionVal = event.target.value;
                variants.forEach((variant) => {
                    // it has to be a click so the class can pass the product id
                    if (variant.value === optionVal) variant.click();
                });
            }),
        );
    }

    const buyButtonsObserver = new IntersectionObserver((_ref) => {
        let [{ isIntersecting: visible }] = _ref;

        if (visible) {
            hideBar();
        } else {
            showBar();
        }
    });

    const footerObserver = new IntersectionObserver((_ref2) => {
        let [{ isIntersecting: visible }] = _ref2;

        if (visible) {
            buyButtonsObserver.disconnect();
            hideBar();
        } else {
            buyButtonsObserver.observe(elements.buyButtons);
        }
    });

    footerObserver.observe(elements.pageFooter);

    const showBar = () => {
        removeClassFromElements(elements.stickyAtcBar, classes.hidden);
    };
    const hideBar = () => {
        addClassToElements(elements.stickyAtcBar, classes.hidden);
    };

    // Update the variant options in the sticky ATC bar

    const updateOptionValues = (variant) => {
        for (let option of elements.optionValues) {
            if (option.value === variant.value) {
                option.selected = true;
            }
        }
    };

    // Update the hidden variant input in the sticky ATC bar
    const updateHiddenVariant = (mainVariantId) => {
        const hiddenVariant = selectElement(selectorsProduct.variantId, elements.stickyAtcBar);
        hiddenVariant.value = mainVariantId;
    };

    const unload = () => {
        buyButtonsObserver === null || buyButtonsObserver === void 0 ? void 0 : buyButtonsObserver.disconnect();
        events.forEach((unsubscribe) => unsubscribe());
        footerObserver === null || footerObserver === void 0 ? void 0 : footerObserver.disconnect();
    };

    return {
        unload,
        updateOptionValues,
        updateHiddenVariant,
    };
}

const selectorsProduct = {
    variant: '[data-variants-type="size"]  .product__variant',
    variantId: ".product-variant-id",
    mediaSwiper: ".swiper.product-media-carousel",
    swiperSlide: ".swiper.product-media-carousel .swiper-slide",
};

register(sectionTypes.mainProduct, {
    onLoad() {
        this.events = [];
        this.swiperMedia = null;
        this.zoomGallery = null;
        this.variants = selectElements(selectorsProduct.variant, this.container);
        this.stickyAddToCart = stickyAtcBar(this.container, this.variants, this.variantId);
        this.mainVariantId = selectElement(selectorsProduct.variantId, this.container);

        const { showStickyAtc, swiperLayout, zoomType } = this.container.dataset;

        showStickyAtc === "true" &&
            addOrRemoveEventListener(this.mainVariantId, "change", (e) => {
                this.stickyAddToCart.updateHiddenVariant(e.target.value);
            });

        for (let variant of this.variants) {
            addOrRemoveEventListener(variant, "change", () => {
                this.stickyAddToCart.updateOptionValues(variant);
            });
        }

        if (swiperLayout == "new_slider" || swiperLayout == "new_slider_thumbnails") {
            this._initializeCarousel(swiperLayout);
        }

        // initialize zoom gallery''
        if (zoomType && zoomType === "lightbox_click") this._initializeZoomGallery();
    },

    _initializeCarousel() {
        import(AF.chunks.swiper).then((_ref) => {
            const { Swiper } = _ref;

            const swiperClasses = {
                pagination: ".swiper-pagination",
                scrollBar: ".swiper-scrollbar",
                next: ".swiper-button-next",
                prev: ".swiper-button-prev",
            };
            let swiperElem = selectElement(selectorsProduct.mediaSwiper, this.container);
            let swiperSlides = selectElements(selectorsProduct.swiperSlide, this.container);

            const {
                isScroll,
                isNavigation,
                isPagination,
                isLoop,
                autoplayDelay,
                slidePerViewMobile,
                slidePerViewTablet,
                slidePerViewDesktop,
            } = swiperElem.dataset;

            const defaultOptions = {
                loop: isLoop === "true",
                autoplay:
                    parseInt(autoplayDelay) > 0
                        ? {
                              delay: parseInt(autoplayDelay),
                              pauseOnMouseEnter: true,
                          }
                        : false,
                scrollbar:
                    isScroll === "true"
                        ? {
                              draggable: false,
                              hide: false,
                              el: swiperClasses.scrollBar,
                          }
                        : false,
                pagination:
                    isPagination === "true"
                        ? {
                              el: swiperClasses.pagination,
                          }
                        : false,
                navigation:
                    isNavigation === "true"
                        ? {
                              nextEl: swiperClasses.next,
                              prevEl: swiperClasses.prev,
                          }
                        : false,
                spaceBetween: 0,
                slidesPerView:
                    swiperSlides.length > parseFloat(slidePerViewMobile) && slidePerViewMobile !== "0"
                        ? parseFloat(slidePerViewMobile)
                        : swiperSlides.length,
                breakpoints: {
                    // when window width is >= 640px
                    768: {
                        slidesPerView:
                            swiperSlides.length > parseFloat(slidePerViewTablet) && slidePerViewTablet !== "0"
                                ? parseFloat(slidePerViewTablet)
                                : swiperSlides.length,
                    },
                    // when window width is >= 991px
                    1025: {
                        slidesPerView:
                            swiperSlides.length > parseFloat(slidePerViewDesktop) && slidePerViewDesktop !== "0"
                                ? parseFloat(slidePerViewDesktop)
                                : swiperSlides.length,
                    },
                },
            };

            this.swiperMedia = new Swiper(selectorsProduct.mediaSwiper, defaultOptions);
        });
    },

    _initializeZoomGallery() {
        console.warn("Initialize zoom gallery");

        const photoswipeClasses = {
            zoomGallery: ".product-media-carousel",
            // Only target buttons that actually have pswp data attributes
            zoomGalleryChildren:
                ".product__media-zoom-lightbox_click[data-pswp-src][data-pswp-width][data-pswp-height]",
        };

        if (selectElement(photoswipeClasses.zoomGallery, this.container)) {
            import(AF.chunks.photoswipe).then((ref) => {
                const { PhotoSwipe, PhotoSwipeLightbox } = ref;

                // Get gallery element first
                const galleryElement = selectElement(photoswipeClasses.zoomGallery, this.container);

                const photo_swipe_options = {
                    gallery: photoswipeClasses.zoomGallery,
                    children: photoswipeClasses.zoomGalleryChildren,

                    /* Click on image moves to the next slide */
                    imageClickAction: "zoom",
                    tapAction: "zoom",

                    /* ## Hiding a specific UI element ## */
                    zoom: true,
                    close: true,
                    counter: false,
                    arrowKeys: true,

                    /* ## Options ## */
                    bgOpacity: "0.8" /* deafult: 0.8 */,
                    showHideOpacity: true,
                    wheelToZoom: true,
                    loop: false,
                    showHideAnimationType: "zoom" /* options: fade, zoom, none */,
                    pswpModule: PhotoSwipe,
                };

                this.zoomGallery = new PhotoSwipeLightbox(photo_swipe_options);

                // Add click handlers to our buttons
                const photoButtons = galleryElement.querySelectorAll(photoswipeClasses.zoomGalleryChildren);
                photoButtons.forEach((button, index) => {
                    button.addEventListener("click", (e) => {
                        e.preventDefault();
                        // Create slide data array from all buttons
                        const slides = Array.from(photoButtons).map((btn) => ({
                            src: btn.getAttribute("data-pswp-src"),
                            width: parseInt(btn.getAttribute("data-pswp-width"), 10),
                            height: parseInt(btn.getAttribute("data-pswp-height"), 10),
                            element: btn,
                        }));

                        // Open PhotoSwipe with specific slide data
                        this.zoomGallery.loadAndOpen(index, slides);
                    });
                });

                this.zoomGallery.init();

                // Debug events
                this.zoomGallery.on("beforeOpen", () => {
                    // This event fires before the lightbox is opened
                });

                this.zoomGallery.on("firstUpdate", () => {
                    // This event fires when the lightbox is first updated
                });

                this.zoomGallery.on("contentLoad", (e) => {
                    // This event fires when content is being loaded
                });

                this.zoomGallery.on("contentLoadComplete", (e) => {
                    // This event fires when content has been loaded
                });

                this.zoomGallery.on("contentLoadError", (e) => {
                    console.error("[PhotoSwipe Debug] contentLoadError - Error loading content:", e);
                });

                this.zoomGallery.on("afterInit", () => {
                    // This event fires after the lightbox has been initialized
                });

                this.zoomGallery.on("closingAnimationStart", () => {
                    // This event fires when the closing animation starts
                });
            });
        }
    },
    onBlockSelect() {},
    onBlockDeselect() {},
    onUnload() {
        if (this.stickyAddToCart) this.stickyAddToCart.unload();
        if (this.swiperMedia) this.swiperMedia.destroy();
        if (this.zoomGallery) this.zoomGallery.destroy();
    },
});

const selectorsFeatCollection = {
    navItems: ".featured-collection-slider__navigation-list-item",
    sliderContainer: ".featured-collection-slider__content.carousel.swiper",
    sliderPagination: ".swiper-pagination",
};
const classesFeatCollection = {
    selected: "selected",
    visible: "visible",
    fadeout: "fadeout",
    initReveal: "init-reveal",
    reveal: "reveal",
};
register(sectionTypes.featuredCollectionSlider, {
    onLoad() {
        this.events = [];
        this.carousels = [];
        if (shouldAnimate(this.container)) {
            this.animateListSlider = animateListSlider(this.container);
        }
        this._initializeCarousels();
    },

    // Initialize carousels
    _initializeCarousels() {
        const {
            productsPerViewDesktop,
            productsPerViewTablet,
            productsPerViewMobile,
            autoplayEnabled,
            autoplayDelay,
            loopEnable,
            spaceBetweenMobile,
            spaceBetweenTablet,
            spaceBetweenDesktop,
        } = this.container.dataset;

        this.loopEnable = loopEnable == "true";
        this.autoplayEnabled = autoplayEnabled == "true";
        this.autoplayDelay = parseInt(autoplayDelay, 10);

        this.carouselsElements = selectElements(selectorsFeatCollection.sliderContainer, this.container);
        this.navItems = selectElements(selectorsFeatCollection.navItems, this.container);
        this.sliderPaginations = selectElements(selectorsFeatCollection.sliderPagination, this.container);

        // Add click event handlers to navigation buttons
        this.navItems.forEach((button) =>
            this.events.push(addOrRemoveEventListener(button, "click", this._handleNavButton.bind(this))),
        );
        this.carouselsElements.forEach((container) => {
            let swiperOptions = {
                centeredSlides: false,
                loop: this.loopEnable,
                mousewheel: {
                    forceToAxis: true,
                },
                autoplay: this.autoplayEnabled
                    ? {
                          delay: this.autoplayDelay,
                          disableOnInteraction: false,
                          pauseOnMouseEnter: true,
                      }
                    : false,

                slidesPerView: productsPerViewMobile != "0" ? parseFloat(productsPerViewMobile) : "auto",
                spaceBetween: spaceBetweenMobile,
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        slidesPerView: productsPerViewTablet != "0" ? parseFloat(productsPerViewTablet) : "auto",
                        spaceBetween: spaceBetweenTablet,
                    },
                    // when window width is >= 1025x
                    1025: {
                        slidesPerView: productsPerViewDesktop != "0" ? parseFloat(productsPerViewDesktop) : "auto",
                        spaceBetween: spaceBetweenDesktop,
                    },
                },
            };

            if (this.sliderPaginations.length > 0) {
                swiperOptions = Object.assign(swiperOptions, {
                    pagination: {
                        el: selectorsFeatCollection.sliderPagination,
                        type: "bullets",
                        clickable: true,
                    },
                });
            }
            this.carousels.push(Carousel(container, swiperOptions));
        });
    },

    // Handle navigation button click
    _handleNavButton(e) {
        e.preventDefault();

        const { navigationItem } = e.currentTarget.dataset;

        if (!hasClass(e.currentTarget, classesFeatCollection.selected)) {
            this._hideAll();
            this._show(parseInt(navigationItem, 10));
        }
    },

    // Hide all carousels and navigation elements
    _hideAll() {
        removeClassFromElements(this.navItems, classesFeatCollection.selected);
        removeClassFromElements(this.carouselsElements, classesFeatCollection.initReveal);
        removeClassFromElements(this.carouselsElements, classesFeatCollection.reveal);

        if (shouldAnimate(this.container)) {
            addClassToElements(this.carouselsElements, classesFeatCollection.fadeout);
            setTimeout(() => {
                removeClassFromElements(this.carouselsElements, classesFeatCollection.visible);
            }, 300);
        } else {
            removeClassFromElements(this.carouselsElements, classesFeatCollection.visible);
        }
    },

    // Show carousel at the specified index
    _show(index) {
        // this are the arrows to navigate <- && ->
        // const navigationWrapper = selectElement(`[data-navigation="${index}"]`, this.container);
        addClassToElements(this.container, classesFeatCollection.visible);

        const collection = selectElement(`[data-collection="${index}"]`, this.container);

        if (this.navItems.length) {
            const navigationItem = selectElement('[data-navigation-item="'.concat(index, '"]'), this.container);
            addClassToElements(navigationItem, classesFeatCollection.selected);
        }

        if (shouldAnimate(this.container)) {
            addClassToElements(collection, classesFeatCollection.fadeout);
            addClassToElements(collection, classesFeatCollection.initReveal);
            setTimeout(() => {
                addClassToElements(collection, classesFeatCollection.visible);
                removeClassFromElements(collection, classesFeatCollection.fadeout);
                setTimeout(() => {
                    addClassToElements(collection, classesFeatCollection.reveal);
                }, 50);
            }, 300);
        } else {
            addClassToElements(collection, classesFeatCollection.visible);
        }
    },

    // Unload event - destroy carousels and animations
    onUnload() {
        let _this$animateListSlid;
        this.carousels.forEach((swiper) => swiper.destroy());
        (_this$animateListSlid = this.animateListSlider) === null || _this$animateListSlid === void 0
            ? void 0
            : _this$animateListSlid.destroy();
        this.events.forEach((unsubscribe) => unsubscribe());
    },

    // Block select event - show carousel based on selected collection
    onBlockSelect({ target }) {
        const { collection } = target.dataset;
        this._hideAll();
        this._show(parseInt(collection, 10));
    },
    onBlockDeselect() {
        return;
    },
});

let selectors_rp = {
    recommendations: "[data-recommendations]",
    sliderContainer: ".swiper.carousel-related",
    sliderPrevBtn: "[data-prev]",
    sliderNextBtn: "[data-next]",
    sliderPagination: ".swiper-pagination",
    sliderNavigation: ".swiper-navigation",
    carouselSlide: ".swiper-slide",
    loadingSpinner: ".loading__spinner",
    timer: "[data-countdown-timer]",
};
const classes_rp = {
    loaded: "product-recommendations--loaded",
    hidden: "hidden",
};
register(sectionTypes.relatedProducts, {
    onLoad() {
        this.countdownTimers = [];
        const content = selectElement(selectors_rp.recommendations, this.container);

        removeClassFromElements(selectElements(selectors_rp.loadingSpinner, content), classes_rp.hidden);
        const { url: requestUrl } = this.container.dataset;

        if (!content) return;

        const request = new XMLHttpRequest();
        request.open("GET", requestUrl, true);

        request.onload = () => {
            if (request.status >= 200 && request.status < 300) {
                let container = document.createElement("div");
                container.innerHTML = request.response;
                content.innerHTML = selectElement(selectors_rp.recommendations, container).innerHTML;

                const carouselElements = selectElements(selectors_rp.carouselSlide, content);
                const timers = selectElements(selectors_rp.timer, this.container);

                timers.length > 0 &&
                    timers.forEach((timer) => {
                        this.countdownTimers.push(CountdownTimer(timer));
                    });

                if (shouldAnimate(this.container)) {
                    this.animateListSlider = animateListSlider(this.container);
                }

                const { isHiddenBasedOnRange, hiddenBasedOnRangeValue } = this.container.dataset;

                if (isHiddenBasedOnRange !== "true") {
                    if (carouselElements.length >= parseInt(hiddenBasedOnRangeValue, 10)) {
                        console.log(carouselElements.length);
                        removeClassFromElements(this.container, classes_rp.hidden);
                        this._initializeCarousel();
                    }
                } else {
                    this._removeSection();
                }
            } else {
                // If request returns any errors remove the section markup
                this._removeSection();
            }
        };

        request.send();
    },
    _initializeCarousel() {
        let {
            mobilePerView,
            perView,
            enableAutoplay,
            delayAutoplay,
            animationSpeed,
            showNavigation,
            showPagination,
            spaceBetweenMobile,
            spaceBetweenTablet,
            spaceBetweenDesktop,
        } = this.container.dataset;

        perView = parseInt(perView, 10);
        mobilePerView = parseInt(mobilePerView, 10);
        delayAutoplay = parseInt(delayAutoplay, 10);
        animationSpeed = parseInt(animationSpeed, 10);
        enableAutoplay = enableAutoplay === "true";
        showPagination = showPagination === "true";
        showNavigation = showNavigation === "true";

        const sliderPagination = selectElement(selectors_rp.sliderPagination, this.container);
        const sliderNavigation = selectElement(selectors_rp.sliderNavigation, this.container);

        let swiperOptions = {
            slidesPerView: mobilePerView,
            spaceBetween: spaceBetweenMobile,
            loop: true,
            simulateTouch: true,
            speed: animationSpeed,
            breakpoints: {
                720: {
                    spaceBetween: spaceBetweenTablet,
                    slidesPerView: perView === 5 ? perView - 1 : perView,
                },
                1200: {
                    spaceBetween: spaceBetweenDesktop,
                    slidesPerView: perView,
                },
            },
        };

        if (enableAutoplay) {
            swiperOptions = Object.assign(swiperOptions, {
                autoplay: {
                    delay: delayAutoplay,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                },
            });
        }

        // Aggiungo l'opzione per la paginazione se abilitata
        if (showPagination) {
            swiperOptions.pagination = {
                el: sliderPagination,
                clickable: true,
            };
        }
        // Aggiungo l'opzione per la navigazione se abilitata
        if (showNavigation) {
            swiperOptions.navigation = {
                nextEl: selectors_rp.sliderNextBtn,
                prevEl: selectors_rp.sliderPrevBtn,
            };
        } else {
            selectElement(selectors_rp.sliderNextBtn, this.container) &&
                removeClassFromElements(selectElement(selectors_rp.sliderNextBtn, this.container), classes_rp.hidden);
            selectElement(selectors_rp.sliderPrevBtn, this.container) &&
                removeClassFromElements(selectElement(selectors_rp.sliderPrevBtn, this.container), classes_rp.hidden);
        }

        this.carousel = Carousel(this.container, swiperOptions);
    },

    _removeSection() {
        this.container.parentNode.removeChild(this.container);
    },
    onUnload() {
        (_this$carousel = this.carousel) === null || _this$carousel === void 0 ? void 0 : _this$carousel.destroy();
    },
});

register(sectionTypes.mainSearch, {
    onLoad() {
        CardProductMediaSlider(this.container);
    },
    onUnload() {
        return;
    },
});

const selectors_csb = {
    sliderContainer: ".swiper",
    sliderPagination: ".swiper-pagination",
};
register(sectionTypes.categorySliderBanner, {
    onLoad() {
        if (shouldAnimate(this.container)) {
            this.animateListSlider = animateListSlider(this.container);
        }
        this.perView = 3;
        this.mobilePerView = 2;
        this._initializeCarousel();
    },

    // initialize carousel
    _initializeCarousel() {
        const {
            paginationStyle, // bullet or dash
            mobilePerView,
            perView,
            enableAutoplay,
            delayAutoplay,
            animationSpeed,
        } = this.container.dataset;

        this.perView = parseInt(perView, 10);
        this.mobilePerView = parseInt(mobilePerView, 10);
        this.sliderPagination = selectElement(selectors_csb.sliderPagination, this.container);
        this.delayAutoplay = parseInt(delayAutoplay, 10);
        this.animationSpeed = parseInt(animationSpeed, 10);
        this.autoplayEnabled = enableAutoplay == "true";

        let swiperOptions = {
            slidesPerView: this.mobilePerView,
            spaceBetween: 10,
            loop: true,
            simulateTouch: true,
            speed: this.animationSpeed,
            breakpoints: {
                720: {
                    spaceBetween: 16,
                    slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView,
                },
                1200: {
                    spaceBetween: 24,
                    slidesPerView: this.perView,
                },
            },
        };
        if (this.autoplayEnabled) {
            swiperOptions = Object.assign(swiperOptions, {
                autoplay: {
                    delay: this.delayAutoplay,
                    pauseOnMouseEnter: true,
                    disableOnInteraction: false,
                },
            });
        }
        if (this.sliderPagination) {
            const paginationType =
                paginationStyle == "dot"
                    ? { type: "bullets" }
                    : {
                          bulletActiveClass: "swiper-pagination-bullet-active--dash",
                          bulletClass: "swiper-pagination-bullet swiper-pagination-bullet--dash",
                      };
            swiperOptions = Object.assign(swiperOptions, {
                pagination: {
                    el: selectorsFeatCollection.sliderPagination,
                    clickable: true,
                    ...paginationType,
                },
            });
        }

        this.carousel = Carousel(this.container, swiperOptions);
    },

    onUnload() {
        let _this$carousel, _this$animateListSlid;
        (_this$carousel = this.carousel) === null || _this$carousel === void 0 ? void 0 : _this$carousel.destroy();
        (_this$animateListSlid = this.animateListSlider) === null || _this$animateListSlid === void 0
            ? void 0
            : _this$animateListSlid.destroy();
    },
});

const selectors_pcb = {
    sliderContainer: ".swiper",
    sliderPagination: ".swiper-pagination",
};
register(sectionTypes.productCarouselBanner, {
    onLoad() {
        if (shouldAnimate(this.container)) {
            this.animateListSlider = animateListSlider(this.container);
        }
        this._initializeCarousel();
    },
    // initialize carousel
    _initializeCarousel() {
        const { mobilePerView, perView, delayAutoplay, animationSpeed } = this.container.dataset;

        this.perView = parseInt(perView, 10);
        this.mobilePerView = parseInt(mobilePerView, 10);
        this.delayAutoplay = parseInt(delayAutoplay, 10);
        this.animationSpeed = parseInt(animationSpeed, 10);

        let swiperOptions = {
            slidesPerView: this.mobilePerView,
            spaceBetween: 10,
            loop: true,
            grabCursor: true,
            simulateTouch: true,
            speed: this.animationSpeed,
            autoplay: {
                delay: 1,
                pauseOnMouseEnter: true,
                disableOnInteraction: false,
            },
            breakpoints: {
                720: {
                    spaceBetween: 16,
                    slidesPerView: this.perView === 5 ? this.perView - 1 : this.perView,
                },
                1200: {
                    spaceBetween: 24,
                    slidesPerView: this.perView,
                },
            },
        };

        this.carousel = Carousel(this.container, swiperOptions);
    },

    onUnload() {
        let _this$carousel, _this$animateListSlid;
        (_this$carousel = this.carousel) === null || _this$carousel === void 0 ? void 0 : _this$carousel.destroy();
        (_this$animateListSlid = this.animateListSlider) === null || _this$animateListSlid === void 0
            ? void 0
            : _this$animateListSlid.destroy();
    },
});

const selectorsMediaSwiper = {
    slide: "[data-slide]",
    swiper: ".swiper",
    navigationPrev: ".slideshow-navigation__navigation-button--previous",
    navigationNext: ".slideshow-navigation__navigation-button--next",
    pagination: ".swiper-pagination",
    animatableItems: ".animation--section-blocks > *",
    pageFooter: "footer",
};

register(sectionTypes.mediaSwper, {
    onLoad() {
        this.events = [];
        this.slideshow = null;
        this.slideshowContainer = selectElement(selectorsMediaSwiper.swiper, this.container);
        this.slides = selectElements(selectorsMediaSwiper.slide, this.container);
        if (shouldAnimate(this.container)) {
            this.slideAnimations = this.slides.map((slide) =>
                delayOffset(slide, [selectorsMediaSwiper.animatableItems], 3),
            );
            this.observer = intersectionWatcher(this.container);
        }
        if (this.slides.length > 1) this._initializeCarousel();
    },
    _initializeCarousel() {
        const { enableAutoplay, autoplayDuration } = this.container.dataset;

        this.enableAutoplay = enableAutoplay === "true";
        this.autoplayDuration = parseInt(autoplayDuration, 10);
        import(AF.chunks.swiper).then((_ref) => {
            let { Swiper } = _ref;

            const swiperOptions = {
                // autoHeight: false,
                slidesPerView: 1,
                grabCursor: true,
                speed: 400,
                loop: true,

                navigation: {
                    nextEl: selectorsMediaSwiper.navigationNext,
                    prevEl: selectorsMediaSwiper.navigationPrev,
                },
                preloadImages: false,
                // if this is true, it negates benefits of lazyloading
                pagination: {
                    el: selectorsMediaSwiper.pagination,
                    clickable: true,
                },
                on: {
                    afterInit: () => {
                        this._handleBulletLabels();
                    },
                    slideChangeTransitionEnd() {
                        const slideEls = this.slides;
                        slideEls.forEach((slide) => {
                            slide.toggleAttribute("inert", !slide.classList.contains("swiper-slide-active"));
                        });
                    },
                },
            };

            if (this.enableAutoplay) {
                swiperOptions.autoplay = {
                    delay: this.autoplayDuration,
                    disableOnInteraction: true,
                    pauseOnMouseEnter: true,
                };
            }
            this.slideshow = new Swiper(this.slideshowContainer, swiperOptions);
        });
    },
    _resetLoaderAnimation(loader) {
        removeClassFromElements(loader, classesMediaSwiper.navigationLoader);
        requestAnimationFrame(() => {
            // double RAF lets the document recompute styles
            requestAnimationFrame(() => {
                addClassToElements(loader, classesMediaSwiper.navigationLoader);
            });
        });
    },
    _pauseSlideshow() {
        this.slideshow.autoplay.stop();
    },
    _playSlideshow() {
        let _this$slideshow;

        (_this$slideshow = this.slideshow) === null || _this$slideshow === void 0
            ? void 0
            : _this$slideshow.autoplay.start();
    },
    _handleFocus() {
        if (hasClass(document.body, "user-is-tabbing")) {
            this._pauseSlideshow();
        }
    },
    _handleBulletLabels() {
        const bullets = selectElements(selectorsMediaSwiper.navigationDot, this.container);
        bullets.forEach((bullet, index) => {
            const associatedSlide = this.slides[index];
            const { bulletLabel } = associatedSlide.dataset;
            bullet.setAttribute("aria-label", bulletLabel);
        });
    },

    _handleBlockSelect(slideIndex) {
        this.slideshow.slideTo(parseInt(slideIndex, 10));
        this._pauseSlideshow();
    },

    _handleBlockDeselect() {
        this._playSlideshow();
    },

    onBlockSelect(_ref4) {
        let { target } = _ref4;
        const { slide } = target.dataset;

        if (this.slideshow) {
            this._handleBlockSelect(slide);
        } else {
            // Listen for initalization if slideshow does not exist
            this.events.push(
                registerListener("slideshow:initialized", () => {
                    this._handleBlockSelect(slide);
                }),
            );
        }
    },
    onBlockDeselect() {
        if (this.slideshow) {
            this._handleBlockDeselect();
        } else {
            // Listen for initalization if slideshow does not exist
            this.events.push(
                registerListener("slideshow:initialized", () => {
                    this._handleBlockDeselect();
                }),
            );
        }
    },
    onUnload() {
        let _this$slideshow2, _this$observer, _this$autoplayObserve, _this$footerObserver;
        (_this$slideshow2 = this.slideshow) === null || _this$slideshow2 === void 0
            ? void 0
            : _this$slideshow2.destroy();
        this.events.forEach((unsubscribe) => unsubscribe());
        (_this$observer = this.observer) === null || _this$observer === void 0 ? void 0 : _this$observer.destroy();
        (_this$autoplayObserve = this.autoplayObserver) === null || _this$autoplayObserve === void 0
            ? void 0
            : _this$autoplayObserve.disconnect();
        (_this$footerObserver = this.footerObserver) === null || _this$footerObserver === void 0
            ? void 0
            : _this$footerObserver.disconnect();
    },
});

/**
 * CountdownTimer - A constructor function for creating countdown timer instances.
 *
 * @param {Element} container - The container element for the countdown timer.
 * @returns {Object} - An object with a destroy method to clear the timer interval.
 */
function CountdownTimer(container) {
    const selectors = {
        settings: "[data-timer-settings]",
        days: "[data-days]",
        hours: "[data-hours]",
        minutes: "[data-minutes]",
        seconds: "[data-seconds]",
    };
    const classes = {
        active: "active",
        hide: "hidden",
        complete: "complete",
    };

    // Extract settings from the container's HTML
    const settings = selectElement(selectors.settings, container);
    const { year, month, day, hour, minute, shopTimezone, timeZoneSelection, hideTimerOnComplete } = JSON.parse(
        settings.innerHTML,
    );

    // Select elements for days, hours, minutes, and seconds
    const daysEl = selectElement(selectors.days, container);
    const hoursEl = selectElement(selectors.hours, container);
    const minutesEl = selectElement(selectors.minutes, container);
    const secondsEl = selectElement(selectors.seconds, container);

    // Construct the timezone string based on the timeZoneSelection
    const timezoneString = timeZoneSelection === "shop" ? " GMT".concat(shopTimezone) : "";

    // Calculate the countdown date and time
    function convertTimezoneOffset(timezone) {
        const match = timezone.match(/([+-])(\d{2})(\d{2})/);
        if (!match) return 0;
        const sign = match[1] === "+" ? 1 : -1;
        const hours = parseInt(match[2], 10);
        const minutes = parseInt(match[3], 10);
        return sign * (hours * 60 + minutes);
    }

    // Usa parametri separati per costruire la data
    const timezoneOffsetMinutes = convertTimezoneOffset(shopTimezone || timeZoneSelection || "+0000");
    const dateInUTC = new Date(Date.UTC(year, month - 1, day, hour, minute));
    const countDownDate = new Date(dateInUTC.getTime() - timezoneOffsetMinutes * 60000);
    const countDownTime = countDownDate.getTime();

    // Set up the timer interval and invoke the initial timerLoop
    const timerInterval = setInterval(timerLoop, 1000);
    timerLoop();

    // Add 'active' class to the container
    addClassToElements(container, classes.active);

    // Timer loop function
    function timerLoop() {
        window.requestAnimationFrame(() => {
            // Get today's date and time
            const now = new Date().getTime();

            // Find the distance between now and the count down date
            const distance = countDownTime - now;

            // Time calculations for days, hours, minutes, and seconds
            const days = Math.floor(distance / (1000 * 60 * 60 * 24));
            const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            const seconds = Math.floor((distance % (1000 * 60)) / 1000);

            // If the count down is finished, update UI and clear the timer interval
            if (distance < 0) {
                timerInterval && clearInterval(timerInterval);

                // Display 0 for days, hours, minutes, and seconds
                daysEl.innerHTML = 0;
                hoursEl.innerHTML = 0;
                minutesEl.innerHTML = 0;
                secondsEl.innerHTML = 0;

                // Add 'complete' class to the container
                addClassToElements(container, classes.complete);
                // Optionally hide the timer on completion
                if (hideTimerOnComplete && !window.Shopify.designMode) {
                    addClassToElements(container.closest("section"), classes.hide);
                }
            } else {
                // Update UI with the remaining time
                daysEl.innerHTML = days;
                hoursEl.innerHTML = hours < 9 ? `0${hours}` : hours;
                minutesEl.innerHTML = minutes < 9 ? `0${minutes}` : minutes;
                secondsEl.innerHTML = seconds < 9 ? `0${seconds}` : seconds;
            }
        });
    }

    // Destroy method to clear the timer interval
    function destroy() {
        timerInterval && clearInterval(timerInterval);
    }

    // Return an object with a destroy method
    return {
        destroy,
    };
}

const selectors$o = {
    timer: "[data-countdown-timer]",
};
register(sectionTypes.countdown.banner, {
    onLoad() {
        const timer = selectElement(selectors$o.timer, this.container);
        this.countdownTimer = null;

        if (timer.dataset.countdownTimer == "classic") this.countdownTimer = CountdownTimer(timer);
        else {
            import(AF.chunks.swiper).then((_ref) => {
                let { Swiper } = _ref;

                const settings = selectElement("[data-timer-settings]", timer);
                const { year, month, day, hour, minute } = JSON.parse(settings.innerHTML);
                const epoch =
                    new Date(
                        Date.parse(
                            "".concat(month, " ").concat(day, ", ").concat(year, " ").concat(hour, ":").concat(minute),
                        ),
                    ).getTime() / 1000;
                import(AF.chunks.flipdown).then((_ref) => {
                    this.countdownTimer = new FlipDown(epoch, selectElement("div", timer).id);
                    this.countdownTimer.start();
                    this.countdownTimer.ifEnded(() => {
                        timer.closest(".AF_countdown").remove();
                    });
                });
            });
        }
    },
    onUnload() {
        let _this$animateCountdow;
        (_this$animateCountdow = this.animateCountdownBanner) === null || _this$animateCountdow === void 0
            ? void 0
            : _this$animateCountdow.destroy();
        this.countdownTimer.destroy();
    },
});

register(sectionTypes.countdown.product, {
    onLoad() {
        this.countdownTimers = [];
        const timers = selectElements(selectors$o.timer, this.container);
        timers.forEach((timer) => {
            this.countdownTimers.push(CountdownTimer(timer));
        });
    },
    onUnload() {
        this.countdownTimers.forEach((countdownTimer) => countdownTimer.destroy());
    },
});

const selectors$q = {
    wash: ".popup__wash",
    dismissButtons: "[data-dismiss-popup]",
    tab: ".popup__tab",
    tabButton: ".popup__tab-button",
    tabDismiss: ".popup__tab-dismiss",
    newsletterForm: ".newsletter-form",
    formSuccessMessage: ".form-status__message--success",
    timer: "[data-countdown-timer]",
};
const classes$a = {
    visible: "visible",
};
/**
 * Popup - A constructor function for creating popup instances.
 *
 * @param {Element} container - The container element for the popup.
 * @returns {Object} - An object with unload, showPopup, and hidePopup methods.
 */
function Popup(container) {
    const popupAnimation = animatePopup(container);

    // Select elements within the popup container
    const wash = selectElement(selectors$q.wash, container);
    const dismissButtons = selectElements(selectors$q.dismissButtons, container);
    const formSuccessMessage = selectElement(selectors$q.formSuccessMessage, container);
    const timer = selectElement(selectors$q.timer, container);
    // Extract data attributes from the container
    const { delayType, showOnExitIntent, id, isSignup, popupType, elementOnClick } = container.dataset;
    // Select related elements based on the extracted data
    const tab = selectElement("".concat(selectors$q.tab, '[data-id="').concat(id, '"'));

    // Parse and set delay values
    let { delayValue, hourFrequency } = container.dataset;
    delayValue = parseInt(delayValue, 10);
    hourFrequency = parseInt(hourFrequency, 10);

    // Set storage keys based on the popup ID
    const storageKey = "popup-".concat(id);
    const signupSubmittedKey = "signup-submitted-".concat(id);
    const formSuccessKey = "form-success-".concat(id);
    const signupDismissedKey = "signup-dismissed-".concat(id);
    const ageVerifiedKey = "age-verified-".concat(id);
    const isSignupPopup = isSignup === "true";
    const isAgeVerification = popupType === "age";

    // Boolean flags to track popup state
    let hasPoppedUp = false;
    let signupSubmitted = Boolean(getStorage(signupSubmittedKey));
    let formSuccessShown = Boolean(getStorage(formSuccessKey));
    let signupDismissed = Boolean(getStorage(signupDismissedKey));
    let ageVerified = Boolean(getStorage(ageVerifiedKey));
    let canPopUp = true;

    // Initialize countdown timer (if available)
    let countdownTimer = null;
    if (timer) {
        countdownTimer = CountdownTimer(timer);
    }

    // Check conditions to determine if the popup should be displayed
    ShouldPopUp();

    // Array to store event listeners
    const events = [];

    if (elementOnClick) {
        const searchElementOnClick = selectElement(elementOnClick, document);
        events.push(addOrRemoveEventListener(searchElementOnClick, "click", showPopup));
    }

    // Check if is not in design mode
    if (!window.Shopify.designMode) {
        events.push(addOrRemoveEventListener(dismissButtons, "click", hidePopup));
    }

    // Add event listeners for dismissing the popup (excluding age verification and on theme editor)
    if (!isAgeVerification && !window.Shopify.designMode) {
        // Only allow wash to be clickable for non age verification popups
        events.push(addOrRemoveEventListener(wash, "click", hidePopup));
        events.push(
            addOrRemoveEventListener(container, "keydown", (_ref) => {
                let { keyCode } = _ref;
                if (keyCode === 27) hidePopup();
            }),
        );
    }

    // Add event listener for newsletter form submission (if it's a signup popup)
    if (isSignupPopup) {
        const form = selectElement(selectors$q.newsletterForm, container);
        if (form) {
            events.push(addOrRemoveEventListener(form, "submit", onNewsletterSubmit));
        }
    }

    // Add event listeners for tab-related actions
    if (tab) {
        const tabButton = selectElement(selectors$q.tabButton, tab);
        const tabDismiss = selectElement(selectors$q.tabDismiss, tab);
        events.push(addOrRemoveEventListener(tabButton, "click", handleTabClick));
        events.push(addOrRemoveEventListener(tabDismiss, "click", hideTab));
    }

    // if is a singupPopup or is a successMessage and success wasn't shown
    if (isSignupPopup && formSuccessMessage && !formSuccessShown) {
        // set storage with the Succed key and date
        setStorage(formSuccessKey, JSON.stringify(new Date()));
        // showPopup
        showPopup();
    } else {
        // Handle delay and exit intent
        handleDelay();

        if (showOnExitIntent === "true") {
            handleExitIntent();
        }
    }

    /**
     * Handles delay before showing the popup.
     */
    function handleDelay() {
        if (!canPopUp) return;

        if (delayType === "timer") {
            setTimeout(() => {
                if (!hasPoppedUp) {
                    showPopup();
                    setStorage(storageKey, JSON.stringify(new Date()));
                }
            }, delayValue);
        } else if (delayType === "scroll") {
            // Delay window / page height calcs until window has loaded
            window.addEventListener(
                "load",
                () => {
                    const scrollPercent = delayValue / 100;
                    const scrollTarget = (document.body.scrollHeight - window.innerHeight) * scrollPercent;
                    const scrollListener = addOrRemoveEventListener(window, "scroll", () => {
                        if (window.scrollY >= scrollTarget) {
                            if (!hasPoppedUp) {
                                showPopup();
                                setStorage(storageKey, JSON.stringify(new Date()));
                            }
                            // Unbind listener
                            scrollListener();
                        }
                    });
                },
                {
                    once: true,
                },
            );
        }
    }

    /**
     * Handles exit intent to show the popup.
     */
    function handleExitIntent() {
        if (!canPopUp) return;

        const bodyLeave = addOrRemoveEventListener(document.body, "mouseout", (e) => {
            if (!e.relatedTarget && !e.toElement) {
                bodyLeave();
                if (!hasPoppedUp) {
                    showPopup();
                    setStorage(storageKey, JSON.stringify(new Date()));
                    hasPoppedUp = true;
                }
            }
        });
    }

    /**
     * Determines if the popup should be displayed based on various conditions.
     */
    function ShouldPopUp() {
        // To avoid popups appearing while in the editor we're disabling them
        // Popups will only be visible in customizer when selected
        if (window.Shopify.designMode) {
            canPopUp = false;
            return;
        }

        // If age has been verified then don't show popup
        // Or signup submitted or dismissed
        // don't show popup
        if ((isAgeVerification && ageVerified) || (isSignupPopup && signupSubmitted)) {
            canPopUp = false;
            return;
        }

        if (isSignupPopup && !signupSubmitted && signupDismissed) {
            canPopUp = false;
            if (tab) {
                showTab();
            }
            return;
        }

        // If no date has been set allow the popup to set the first when opened
        if (!isSignupPopup && !isAgeVerification && !getStorage(storageKey)) {
            return;
        }

        // Compare set date and allowed popup frequency hour diff
        const timeStart = new Date(getStorage(storageKey));
        const timeEnd = new Date();
        const hourDiff = (timeEnd - timeStart) / 1000 / 60 / 60;

        // Will not allow popup if the hour frequency is below the previously
        // set poppedup date.
        canPopUp = hourDiff > hourFrequency;
    }
    function handleTabClick() {
        showPopup();
        if (popupType === "flyout" && !window.Shopify.designMode) {
            const focusable = selectElement("button, [href], input, select, textarea", container);
            if (focusable) {
                focusable.focus({
                    preventScroll: true,
                });
            }
        }
    }
    function showPopup() {
        addClassToElements(container, classes$a.visible);
        addClassToElements(document.body, "overflow-hidden");
        popupAnimation.open();

        if (popupType === "popup" || popupType === "age") {
            if (!window.Shopify.designMode) {
                trapFocus(container);
            }
            document.body.setAttribute("data-fluorescent-overlay-open", "true");
        }
        hasPoppedUp = true;
        if (window.Shopify.designMode && tab) {
            // Show tab in theme editor
            showTab();
        } else if (tab) {
            // hide tab on popup open
            removeClassFromElements(tab, classes$a.visible);
        }
    }
    function hidePopup() {
        removeClassFromElements(container, classes$a.visible);
        removeClassFromElements(document.body, "overflow-hidden");
        if (isSignupPopup) {
            setStorage(signupDismissedKey, JSON.stringify(new Date()));
            // show tab on close, clicking the tab will open the popup again
            if (tab) {
                showTab();
            }
        }

        // Set storage when age verification popup has been dismissed
        // Age verification popups will always be shown until they are dismissed
        if (isAgeVerification) {
            setStorage(ageVerifiedKey, JSON.stringify(new Date()));
        }
        setTimeout(() => {
            popupAnimation.close();
            if (popupType === "popup" || popupType === "age") {
                removeTrapFocus();
                document.body.setAttribute("data-fluorescent-overlay-open", "false");
                // enableBodyScroll(container);
            }
        }, 500);
    }
    function showTab() {
        addClassToElements(tab, classes$a.visible);
    }
    function hideTab() {
        removeClassFromElements(tab, classes$a.visible);
        // When tab is removed we want the popup to be able to open again if it has a frequency
        // We have to remove the storeage saying that the popup was dismissed
        removeStorage(signupDismissedKey);
    }
    function onNewsletterSubmit() {
        setStorage(signupSubmittedKey, JSON.stringify(new Date()));
    }
    function unload() {
        hidePopup();
        events.forEach((unsubscribe) => unsubscribe());
        if (isAgeVerification) {
            // enableBodyScroll(container);
        }
        countdownTimer && countdownTimer.destroy();
    }
    return {
        unload,
        showPopup,
        hidePopup,
    };
}

register(sectionTypes.popup, {
    onLoad() {
        this.popups = selectElements("[data-popup]", this.container).map((popup) => {
            return {
                contructor: Popup(popup),
                element: popup,
            };
        });
    },
    onBlockSelect(_ref) {
        let { target } = _ref;

        const targetPopup = this.popups.find((o) => o.element === target);
        targetPopup.contructor.showPopup();
    },
    onBlockDeselect(_ref2) {
        let { target } = _ref2;

        const targetPopup = this.popups.find((o) => o.element === target);
        targetPopup.contructor.hidePopup();
    },
    onUnload() {
        this.popups.forEach((popup) => {
            let _popup$contructor;
            return (_popup$contructor = popup.contructor) === null || _popup$contructor === void 0
                ? void 0
                : _popup$contructor.unload();
        });
    },
});

/*
  TODO: DA RIPULIRE IL CODICE
 */
//Accordion footer mobile
const pool = [];
const inAnimItems = {
    add(el, defaultStyle, timeoutId, onCancelled) {
        const inAnimItem = { el, defaultStyle, timeoutId, onCancelled };
        this.remove(el);
        pool.push(inAnimItem);
    },
    remove(el) {
        const index = inAnimItems.findIndex(el);
        if (index === -1) return;
        const inAnimItem = pool[index];
        clearTimeout(inAnimItem.timeoutId);
        inAnimItem.onCancelled();
        pool.splice(index, 1);
    },
    find(el) {
        return pool[inAnimItems.findIndex(el)];
    },
    findIndex(el) {
        let index = -1;
        pool.some((item, i) => {
            if (item.el === el) {
                index = i;
                return true;
            }
            return false;
        });
        return index;
    },
};

const CSS_EASEOUT_EXPO = "cubic-bezier( 0.19, 1, 0.22, 1 )";
function slideDown(el, options = {}) {
    return new Promise((resolve) => {
        if (inAnimItems.findIndex(el) !== -1) return;
        const _isVisible = isVisible(el);
        const hasEndHeight = typeof options.endHeight === "number";
        const display = options.display || "block";
        const duration = options.duration || 400;
        const onCancelled = options.onCancelled || function () {};
        const defaultStyle = el.getAttribute("style") || "";
        const style = window.getComputedStyle(el);
        const defaultStyles = getDefaultStyles(el, display);
        const isBorderBox = /border-box/.test(style.getPropertyValue("box-sizing"));
        const contentHeight = defaultStyles.height;
        const minHeight = defaultStyles.minHeight;
        const paddingTop = defaultStyles.paddingTop;
        const paddingBottom = defaultStyles.paddingBottom;
        const borderTop = defaultStyles.borderTop;
        const borderBottom = defaultStyles.borderBottom;
        const cssDuration = `${duration}ms`;
        const cssEasing = CSS_EASEOUT_EXPO;
        const cssTransition = [
            `height ${cssDuration} ${cssEasing}`,
            `min-height ${cssDuration} ${cssEasing}`,
            `padding ${cssDuration} ${cssEasing}`,
            `border-width ${cssDuration} ${cssEasing}`,
        ].join();
        const startHeight = _isVisible ? style.height : "0px";
        const startMinHeight = _isVisible ? style.minHeight : "0px";
        const startPaddingTop = _isVisible ? style.paddingTop : "0px";
        const startPaddingBottom = _isVisible ? style.paddingBottom : "0px";
        const startBorderTopWidth = _isVisible ? style.borderTopWidth : "0px";
        const startBorderBottomWidth = _isVisible ? style.borderBottomWidth : "0px";
        const endHeight = (() => {
            if (hasEndHeight) return `${options.endHeight}px`;
            return !isBorderBox
                ? `${contentHeight - paddingTop - paddingBottom}px`
                : `${contentHeight + borderTop + borderBottom}px`;
        })();
        const endMinHeight = `${minHeight}px`;
        const endPaddingTop = `${paddingTop}px`;
        const endPaddingBottom = `${paddingBottom}px`;
        const endBorderTopWidth = `${borderTop}px`;
        const endBorderBottomWidth = `${borderBottom}px`;
        if (
            startHeight === endHeight &&
            startPaddingTop === endPaddingTop &&
            startPaddingBottom === endPaddingBottom &&
            startBorderTopWidth === endBorderTopWidth &&
            startBorderBottomWidth === endBorderBottomWidth
        ) {
            resolve();
            return;
        }
        requestAnimationFrame(() => {
            el.style.height = startHeight;
            el.style.minHeight = startMinHeight;
            el.style.paddingTop = startPaddingTop;
            el.style.paddingBottom = startPaddingBottom;
            el.style.borderTopWidth = startBorderTopWidth;
            el.style.borderBottomWidth = startBorderBottomWidth;
            el.style.display = display;
            el.style.overflow = "hidden";
            el.style.visibility = "visible";
            el.style.transition = cssTransition;
            el.style.webkitTransition = cssTransition;
            requestAnimationFrame(() => {
                el.style.height = endHeight;
                el.style.minHeight = endMinHeight;
                el.style.paddingTop = endPaddingTop;
                el.style.paddingBottom = endPaddingBottom;
                el.style.borderTopWidth = endBorderTopWidth;
                el.style.borderBottomWidth = endBorderBottomWidth;
            });
        });
        const timeoutId = setTimeout(() => {
            resetStyle(el);
            el.style.display = display;
            if (hasEndHeight) {
                el.style.height = `${options.endHeight}px`;
                el.style.overflow = `hidden`;
            }
            inAnimItems.remove(el);
            resolve();
        }, duration);
        inAnimItems.add(el, defaultStyle, timeoutId, onCancelled);
    });
}

function slideUp(el, options = {}) {
    return new Promise((resolve) => {
        if (inAnimItems.findIndex(el) !== -1) return;

        const _isVisible = isVisible(el);
        const display = options.display || "block";
        const duration = options.duration || 400;
        const onCancelled = options.onCancelled || function () {};
        if (!_isVisible) {
            resolve();
            return;
        }
        const defaultStyle = el.getAttribute("style") || "";
        const style = window.getComputedStyle(el);
        const isBorderBox = /border-box/.test(style.getPropertyValue("box-sizing"));
        const minHeight = pxToNumber(style.getPropertyValue("min-height"));
        const paddingTop = pxToNumber(style.getPropertyValue("padding-top"));
        const paddingBottom = pxToNumber(style.getPropertyValue("padding-bottom"));
        const borderTop = pxToNumber(style.getPropertyValue("border-top-width"));
        const borderBottom = pxToNumber(style.getPropertyValue("border-bottom-width"));
        const contentHeight = el.scrollHeight;
        const cssDuration = duration + "ms";
        const cssEasing = CSS_EASEOUT_EXPO;
        const cssTransition = [
            `height ${cssDuration} ${cssEasing}`,
            `padding ${cssDuration} ${cssEasing}`,
            `border-width ${cssDuration} ${cssEasing}`,
        ].join();
        const startHeight = !isBorderBox
            ? `${contentHeight - paddingTop - paddingBottom}px`
            : `${contentHeight + borderTop + borderBottom}px`;
        const startMinHeight = `${minHeight}px`;
        const startPaddingTop = `${paddingTop}px`;
        const startPaddingBottom = `${paddingBottom}px`;
        const startBorderTopWidth = `${borderTop}px`;
        const startBorderBottomWidth = `${borderBottom}px`;
        requestAnimationFrame(() => {
            el.style.height = startHeight;
            el.style.minHeight = startMinHeight;
            el.style.paddingTop = startPaddingTop;
            el.style.paddingBottom = startPaddingBottom;
            el.style.borderTopWidth = startBorderTopWidth;
            el.style.borderBottomWidth = startBorderBottomWidth;
            el.style.display = display;
            el.style.overflow = "hidden";
            el.style.transition = cssTransition;
            el.style.webkitTransition = cssTransition;
            requestAnimationFrame(() => {
                el.style.height = "0";
                el.style.minHeight = "0";
                el.style.paddingTop = "0";
                el.style.paddingBottom = "0";
                el.style.borderTopWidth = "0";
                el.style.borderBottomWidth = "0";
            });
        });
        const timeoutId = setTimeout(() => {
            resetStyle(el);
            el.style.display = "none";
            inAnimItems.remove(el);
            resolve();
        }, duration);
        inAnimItems.add(el, defaultStyle, timeoutId, onCancelled);
    });
}

function slideStop(el) {
    const elementObject = inAnimItems.find(el);
    if (!elementObject) return;
    const style = window.getComputedStyle(el);
    const height = style.height;
    const paddingTop = style.paddingTop;
    const paddingBottom = style.paddingBottom;
    const borderTopWidth = style.borderTopWidth;
    const borderBottomWidth = style.borderBottomWidth;
    resetStyle(el);
    el.style.height = height;
    el.style.paddingTop = paddingTop;
    el.style.paddingBottom = paddingBottom;
    el.style.borderTopWidth = borderTopWidth;
    el.style.borderBottomWidth = borderBottomWidth;
    el.style.overflow = "hidden";
    inAnimItems.remove(el);
}

function isVisible(el) {
    return el.offsetHeight !== 0;
}

function resetStyle(el) {
    el.style.visibility = "";
    el.style.height = "";
    el.style.minHeight = "";
    el.style.paddingTop = "";
    el.style.paddingBottom = "";
    el.style.borderTopWidth = "";
    el.style.borderBottomWidth = "";
    el.style.overflow = "";
    el.style.transition = "";
    el.style.webkitTransition = "";
}

function getDefaultStyles(el, defaultDisplay = "block") {
    const defaultStyle = el.getAttribute("style") || "";
    const style = window.getComputedStyle(el);
    el.style.visibility = "hidden";
    el.style.display = defaultDisplay;
    const width = pxToNumber(style.getPropertyValue("width"));
    el.style.position = "absolute";
    el.style.width = `${width}px`;
    el.style.height = "";
    el.style.minHeight = "";
    el.style.paddingTop = "";
    el.style.paddingBottom = "";
    el.style.borderTopWidth = "";
    el.style.borderBottomWidth = "";
    const minHeight = pxToNumber(style.getPropertyValue("min-height"));
    const paddingTop = pxToNumber(style.getPropertyValue("padding-top"));
    const paddingBottom = pxToNumber(style.getPropertyValue("padding-bottom"));
    const borderTop = pxToNumber(style.getPropertyValue("border-top-width"));
    const borderBottom = pxToNumber(style.getPropertyValue("border-bottom-width"));
    const height = el.scrollHeight;
    el.setAttribute("style", defaultStyle);
    return {
        height,
        minHeight,
        paddingTop,
        paddingBottom,
        borderTop,
        borderBottom,
    };
}
function pxToNumber(px) {
    return +px.replace(/px/, "");
}

const selectors$x = {
    disclosure: "[data-disclosure]",
    header: "[data-header]",
};

// Funzione riutilizzabile per gestire l'accordion anche nel menu-block
function handleAccordionClick(event) {
    const { currentTarget } = event;

    toggleClassOnElements(currentTarget, "open", !isVisible(currentTarget.nextElementSibling));

    slideStop(currentTarget.nextElementSibling);
    if (isVisible(currentTarget.nextElementSibling)) {
        slideUp(currentTarget.nextElementSibling);
    } else {
        slideDown(currentTarget.nextElementSibling);
    }
}
// fine funzione riutilizzabile per gestire l'accordion anche nel menu-block

register(sectionTypes.footer, {
    onLoad() {
        const headers = selectElements(selectors$x.header, this.container);

        this.headerClick = addOrRemoveEventListener(headers, "click", this._handleHeaderClick);

        this._fixedFooter();
    },
    onSelect() {
        this._fixedFooter();
    },

    onDeselect() {
        this._fixedFooter();
    },

    _handleHeaderClick(_ref) {
        const { currentTarget } = _ref;

        toggleClassOnElements(currentTarget, "open", !isVisible(currentTarget.nextElementSibling));

        slideStop(currentTarget.nextElementSibling);
        if (isVisible(currentTarget.nextElementSibling)) {
            slideUp(currentTarget.nextElementSibling);
        } else {
            slideDown(currentTarget.nextElementSibling);
        }
    },
    //accordion footer handleclick

    _fixedFooter() {
        const container = this.container;
        /*     const prevSiblEl = container.parentElement.previousSibling; */
        let containerHeight = container.offsetHeight;
        let footerHeight = container.getBoundingClientRect().height;

        function handleDisableFooter() {
            const scrollPosition = window.scrollY + window.innerHeight;
            const bodyHeight = document.body.clientHeight;
            const pointEvent = bodyHeight - footerHeight;
            // If the scroll position is greater than the height of the div container
            if (scrollPosition >= pointEvent) {
                // Change the display property of the container to 'block'
                container.style.display = "block";
            } else {
                // Otherwise, make it invisible
                container.style.display = "none";
            }

            if (scrollPosition === document.body.clientHeight) {
                container.style.boxShadow = "black 0px -10rem 0px 15vh";
            } else {
                container.style.boxShadow = "none";
            }
        }

        /*     function _handleClickFooterMenu() {
      const footerMenuHeader = document.querySelectorAll("button.footer__header");
      footerMenuHeader.forEach((element)=> {
        element.addEventListener("click", () => {
          setTimeout(()=>{
          containerHeight = container.offsetHeight;
          document.body.style.paddingBottom = Math.floor(containerHeight) + 'px';
        },200);
        });

      });
    } */

        if (container.dataset.sectionFixed == "true" && window.screen.width >= 991) {
            addClassToElements(container, "fixed-footer");
            window.addEventListener("scroll", handleDisableFooter);
            //  _handleClickFooterMenu();
            document.body.style.paddingBottom = Math.floor(containerHeight) + "px";
        } else {
            removeClassFromElements(container, "fixed-footer");
            document.body.style.paddingBottom = 0;
        }
    },

    onUnload() {
        this.headerClick();
    },
});

// Gestione accordion per menu-block
document.addEventListener("DOMContentLoaded", function () {
    const menuBlocks = document.querySelectorAll(".menu-block");

    menuBlocks.forEach((block) => {
        const headers = block.querySelectorAll("[data-header]");

        headers.forEach((header) => {
            header.addEventListener("click", handleAccordionClick);
        });
    });
});
// Fine gestione accordion per menu-block

const VideoAudioOnOff = (node) => {
    const selectors = {
        video: "video",
        toggle: "[data-toggle-sound]",
        soundOn: "[data-sound-on]",
        soundOff: "[data-sound-off]",
        volumeRange: "[data-volume-range]",
        fillerVolume: ".bar-fill",
        volumeBar: ".bar-hoverbox",
        volumeContainer: ".video-volume-container",
    };
    const elements = {
        video: selectElement(selectors.video, node),
        volumeRange: selectElement(selectors.volumeRange, node),
        fillerVolume: selectElement(selectors.fillerVolume, node),
        toggle: selectElement(selectors.toggle, node),
        soundOn: selectElement(selectors.soundOn, node),
        soundOff: selectElement(selectors.soundOff, node),
        volumeContainer: selectElement(selectors.volumeContainer, node),
    };

    let setValue = (value) => {
        elements.fillerVolume.style.transform = `scaleY(${value / 100.0})`;
        elements.volumeRange.setAttribute("value", value);
        elements.video.volume = value / 100;
        elements.volumeRange.dispatchEvent(new Event("change"));
    };
    if (elements.video.readyState === 4) {
        if (!hasAudio()) {
            elements.volumeContainer.remove();
            return;
        }
    }
    setValue(elements.volumeRange.value);

    function calculateFillerVolume(e) {
        let offsetY = e.offsetY;

        if (e.type === "touchmove") {
            offsetY = e.touches[0].pageY - e.touches[0].target.offsetBottom;
        }

        const height = e.target.offsetHeight - 30;

        setValue(Math.max(Math.min((((offsetY - 115) * -1) / height) * 100.0, 100.0), 0));
    }

    function toggleSound() {
        elements.video.muted = !elements.video.muted;
        if (elements.video.muted) {
            elements.soundOn.dataset.soundOn = "false";
            elements.soundOff.dataset.soundOff = "true";
            selectElement(selectors.volumeBar, node).parentElement.dataset.sound = "off";
        } else {
            elements.soundOn.dataset.soundOn = "true";
            elements.soundOff.dataset.soundOff = "false";
            selectElement(selectors.volumeBar, node).parentElement.dataset.sound = "on";
        }
    }

    function addListeners() {
        let volumeBar = selectElement(selectors.volumeBar, node);

        addOrRemoveEventListener(elements.toggle, "click", toggleSound.bind(this));

        let barStillDown = false;

        addOrRemoveEventListener(volumeBar, "touchstart", (e) => {
            barStillDown = true;
            calculateFillerVolume(e);
        });
        addOrRemoveEventListener(volumeBar, "touchmove", (e) => {
            if (barStillDown) {
                calculateFillerVolume(e);
            }
        });
        addOrRemoveEventListener(volumeBar, "mousedown", (e) => {
            barStillDown = true;
            calculateFillerVolume(e);
        });
        addOrRemoveEventListener(volumeBar, "mousemove", (e) => {
            if (barStillDown) {
                calculateFillerVolume(e);
            }
        });
        addOrRemoveEventListener(volumeBar, "wheel", (e) => {
            const newValue = +elements.volumeRange.value + e.deltaY * 0.5;
            setValue(Math.max(Math.min(newValue, 100.0), 0));
        });
        addOrRemoveEventListener(document, "mouseup", () => {
            barStillDown = false;
        });
        addOrRemoveEventListener(elements.volumeRange, "touchend", () => {
            barStillDown = false;
        });
    }

    function hasAudio() {
        if (typeof elements.video.webkitAudioDecodedByteCount !== "undefined") {
            // non-zero if video has audio track
            if (elements.video.webkitAudioDecodedByteCount > 0) {
                return true;
            } else return false;
        } else if (typeof elements.video.mozHasAudio !== "undefined") {
            // true if video has audio track
            if (elements.video.mozHasAudio) {
                return true;
            } else return false;
        } else throw new Error("hasAudio: Audio track presence could not be determined.");
    }
    return {
        addListeners,
        hasAudio,
    };
};

register(sectionTypes.videoBanner, {
    onLoad() {
        if (this.container.dataset.controlVolume === "true") {
            this.videoAudioOnOff = VideoAudioOnOff(this.container);
            this.videoAudioOnOff.addListeners();
        }
    },

    onSelect() {
        if (this.container.dataset.controlVolume === "true") {
            this.videoAudioOnOff = VideoAudioOnOff(this.container);
            this.videoAudioOnOff.addListeners();
        }
    },

    onBlockSelect() {
        if (this.container.dataset.controlVolume === "true") {
            this.videoAudioOnOff = VideoAudioOnOff(this.container);
            this.videoAudioOnOff.addListeners();
        }
    },

    onUnload() {},
});

/**
 * Represents a card product media slider.
 *
 * @param {HTMLElement} node - The root element of the slider.
 * @returns {Object} - An object with a `destroy` method to destroy the slider.
 */
const CardProductMediaSlider = function (node) {
    const cardProductsContainer = selectElements(".swiper", node);
    let mediaCarousel;

    import(AF.chunks.swiper).then((_ref) => {
        let { Swiper } = _ref;

        cardProductsContainer.forEach((container) => {
            const nextButton = selectElement("[data-product-card-next]", container);
            const prevButton = selectElement("[data-product-card-prev]", container);

            let swiperOptions = {
                slidesPerView: 1,
                spaceBetween: 0,
                centeredSlides: false,
                loop: true,
                autoplay: false,
                grabCursor: true,
                simulateTouch: true,
                navigation: {
                    nextEl: nextButton,
                    prevEl: prevButton,
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                    bulletActiveClass: "swiper-pagination-bullet-active--dash",
                    bulletClass: "swiper-pagination-bullet swiper-pagination-bullet--dash",
                },
            };

            mediaCarousel = new Swiper(container, swiperOptions);
        });
    });

    return {
        destroy: () => {
            let _carousel;
            (_carousel = mediaCarousel) === null || _carousel === void 0 ? void 0 : _carousel.destroy();
        },
    };
};

// FILE: sections/main-collection-product-grid.liquidAdd commentMore actions
register(sectionTypes.mainCollection, {
    onLoad() {
        const { collectionItemCount, showCardSwiper } = this.container.dataset;

        if (!parseInt(collectionItemCount) && showCardSwiper == "none") return;
        this.__initializeCardCarousel(showCardSwiper);
    },

    __initializeCardCarousel(showCardSwiper) {
        switch (showCardSwiper) {
            case "mobile":
                {
                    if (typeof this._swiperInitialized === "undefined") this._swiperInitialized = false;
                    if (typeof this._unsubscribe === "undefined") this._unsubscribe = null;
                    const initSwiper = () => {
                        const isMobile = window.matchMedia(getMediaQuery("below-960")).matches;
                        if (isMobile && !this._swiperInitialized) {
                            // Still subscribe for dynamically loaded cards
                            this._unsubscribe = subscribe("load-products-swiper", ({ elementTarget }) => {
                                CardProductMediaSlider(elementTarget);
                            });
                            this._swiperInitialized = true;
                        } else if (!isMobile && this._swiperInitialized) {
                            if (this._unsubscribe) this._unsubscribe();
                            this._swiperInitialized = false;
                        }
                    };
                    initSwiper();
                    atBreakpointChange(960, initSwiper);
                }
                break;
            case "desktop":
                {
                    if (typeof this._swiperInitialized === "undefined") this._swiperInitialized = false;
                    if (typeof this._unsubscribe === "undefined") this._unsubscribe = null;
                    const initSwiper = () => {
                        const isDesktop = window.matchMedia(getMediaQuery("above-960")).matches;
                        if (isDesktop && !this._swiperInitialized) {
                            this._unsubscribe = subscribe("load-products-swiper", ({ elementTarget }) => {
                                CardProductMediaSlider(elementTarget);
                            });
                            this._swiperInitialized = true;
                        } else if (!isDesktop && this._swiperInitialized) {
                            if (this._unsubscribe) this._unsubscribe();
                            this._swiperInitialized = false;
                        }
                    };
                    initSwiper();
                    atBreakpointChange(960, initSwiper);
                }
                break;
            case "both":
                subscribe("load-products-swiper", ({ elementTarget }) => {
                    CardProductMediaSlider(elementTarget);
                });
                break;
        }
    },

    onUnload() {
        if (this._unsubscribe) this._unsubscribe();
    },
});

const selectorsGigaMenu = {
    gigaLink: "[data-giga-link]",
    gigaNavList: "[data-nav-list] li",
    subMenuList: "[data-sub-menu-link-list] > div",
    gigaMenuContent: "#giga-menu-content",
};

const classesGigaMenu = {
    not_hoverable: "not_hoverable",
};

register(sectionTypes.header.gigaMenu, {
    onLoad() {
        this.events = [];
        const menu = this.container;
        // for the click event get the link
        const link = selectElement(selectorsGigaMenu.gigaLink, menu);
        // get the eventType from the dataset
        const { eventType } = this.container.dataset;

        this.gigaNavList = selectElements(selectorsGigaMenu.gigaNavList, this.container);
        this.subMenuList = selectElements(selectorsGigaMenu.subMenuList, this.container);
        this.blockSelected = false;

        if (eventType === "hover") {
            (addOrRemoveEventListener(menu, "mouseover", this._handleToggleMenu.bind(this)),
                addOrRemoveEventListener(menu, "mouseout", this._handleToggleMenu.bind(this)));
        }
        if (eventType === "click") {
            this.events.push(addOrRemoveEventListener(link, "click", this._handleToggleMenu.bind(this)));
        }
        this.gigaNavList.forEach((subMenu) => {
            if (hasClass(selectElement("a", subMenu), classesGigaMenu.not_hoverable)) return;
            addOrRemoveEventListener(subMenu, "mouseover", this._handleToggleSubMenu.bind(this));
        });
    },
    // show, for every submenu, the link list connected to it
    _handleToggleSubMenu(e) {
        const currentId = e.currentTarget.id;

        // for the submenu link list, remove the class hidden and add it to the others
        this.subMenuList.forEach((menu) => {
            // get the submenu id from dataset
            const { submenuId } = menu.dataset;

            // toogle the class hidden for the submenu link list if the one hovered has the same id
            if (submenuId === currentId) {
                // show the submenu link list
                addClassToElements(e.currentTarget, "active");
                removeClassFromElements(menu, "hidden");
            } else {
                // hide the submenu link list
                selectElement("#" + submenuId, this.container).classList.remove("active");
                addClassToElements(menu, "hidden");
            }
        });
    },
    // Close / Open the giga menu
    _handleToggleMenu(e) {
        if (window.Shopify.designMode && this.blockSelected) return;

        if (e.type === "click") e.preventDefault();

        if (this.container.hasAttribute("open") || e.type === "mouseout") {
            //Close the menu
            this.container.removeAttribute("open");
        } else {
            // Open the menu
            this._openGigaMenu();
        }
    },

    _openGigaMenu() {
        this.container.setAttribute("open", "");
        const content = selectElement(selectorsGigaMenu.gigaMenuContent, this.container);
        content.removeAttribute("style");
    },

    onBlockSelect(block) {
        this.blockSelected = true;
        const target = block.srcElement.dataset.targetId;

        // Open the menu
        this._openGigaMenu();

        if (target) {
            // get the target submenu
            this.subMenuList.forEach((menu) => {
                // get the submenu id from dataset
                const { submenuId } = menu.dataset;

                // toogle the class hidden for the submenu link list if the one hovered has the same id
                if (submenuId === target) {
                    // show the submenu link list
                    addClassToElements(selectElement("#" + target, this.container), "active");
                    removeClassFromElements(menu, "hidden");
                } else {
                    // hide the submenu link list
                    selectElement("#" + submenuId, this.container).classList.remove("active");
                    addClassToElements(menu, "hidden");
                }
            });
        }
    },
    onBlockDeselect() {
        this.blockSelected = false;
        this.container.removeAttribute("open");
    },

    onUnload() {
        // Remove event listeners
        if (this.events.length > 0) this.events.forEach((event) => removeEventListener(event));
    },
});

const selectorsNewNavHeader = {
    mainNavContainer: ".nav-drawer-container",
    burgerNav: "#NavOpener",
    section: ".shopify-section",
    swiper: ".swiper.nav-container",
    menuItemTabs: "#level_0 .swiper-slide .list-menu__item.selectable_tab",
    menus: ".menu-drawer__menus > .menu-drawer__menu",
    submenus: "li.has_submenu",
    navNextEl: ".swiper-button-next",
    navPrevEl: ".swiper-button-prev",
};
const classesNewNavHeader = {
    menuOpen: "menu-open",
    selectedTab: "selected_tab",
    selectedMenu: "selected_menu",
    submenuOpen: "submenu_open",
    hidden: "hidden",
};
register(sectionTypes.header.newNavDrawer, {
    onLoad() {
        this.events = [];
        this.slider = null;

        const { debugging } = this.container.dataset;

        let navOpener = selectElement(selectorsNewNavHeader.burgerNav, this.container);

        this.events.push(addOrRemoveEventListener(navOpener, "click", this._handleToggleMainMenu.bind(this)));

        if (debugging === "true") navOpener.click();

        if (selectElement(selectorsNewNavHeader.mainNavContainer, this.container).hasAttribute("open")) {
            this._initializeCarousel();
        }
    },

    _initializeCarousel() {
        import(AF.chunks.swiper).then((_ref) => {
            let { Swiper } = _ref;

            const swiperOptions = {
                slidesPerView: 3,
                lazy: {
                    enabled: true,
                    loadPrevNext: true,
                },
                speed: 400,
                mousewheel: true,
                touches: true,
                watchOverflow: true,
                allowTouchMove: true,
                simulateTouch: true,
                navigation: {
                    nextEl: selectorsNewNavHeader.navNextEl,
                    prevEl: selectorsNewNavHeader.navPrevEl,
                },
            };

            this.slider = new Swiper(selectorsNewNavHeader.swiper, swiperOptions);
        });
    },
    // Close / Open the giga menu
    _handleToggleMainMenu(e) {
        // if is design mode do not let event listener
        // if (window.Shopify.designMode && this.blockSelected) return;
        let mainNavEl = e.target.closest(selectorsNewNavHeader.mainNavContainer);

        if (mainNavEl.hasAttribute("open")) {
            //Close the menu
            this._closeNewNavHeader(mainNavEl);
        } else {
            this._handle_main_menu_is_opened(mainNavEl);
        }
    },
    _handle_main_menu_is_opened(mainNavEl) {
        // initialize slider
        !this.slider && this._initializeCarousel();

        // select drawer_menu tab items
        this.tab_tems = selectElements(selectorsNewNavHeader.menuItemTabs, this.container);
        this.tab_tems.forEach((el) => {
            this.events.push(addOrRemoveEventListener(el, "click", this._change_to_child_menu_tab.bind(this)));
        });
        // Open the menu
        this._openNewNavHeader(mainNavEl);
    },
    _closeNewNavHeader(el) {
        removeClassFromElements(document.body, "overflow-hidden");
        el.removeAttribute("open");
        removeClassFromElements(el.closest(selectorsNewNavHeader.section), classesNewNavHeader.menuOpen);
    },

    _openNewNavHeader(el) {
        if (!el) return;
        addClassToElements(document.body, "overflow-hidden");
        smoothScrollToTarget(el);
        addClassToElements(el.closest(selectorsNewNavHeader.section), classesNewNavHeader.menuOpen);
        el.setAttribute("open", "");
    },

    _change_to_child_menu_tab(event) {
        event.preventDefault();
        //remove active class from all
        this.tab_tems.forEach((item) => {
            item.classList.remove(classesNewNavHeader.selectedTab);
        });

        let el = event.target;

        // add class active on target
        addClassToElements(el, classesNewNavHeader.selectedTab);

        let menus = selectElements(selectorsNewNavHeader.menus, this.container);

        menus.forEach((menu) => {
            // show menu
            if (menu.dataset.forIdx == el.dataset.idx) {
                removeClassFromElements(menu, classesNewNavHeader.hidden);
                addClassToElements(menu, classesNewNavHeader.selectedMenu);

                selectElements(selectorsNewNavHeader.submenus, menu).forEach((subContainer) => {
                    let subMenus = selectElements("[data-idx]", subContainer);

                    subMenus.forEach((sub) => {
                        this.events.push(addOrRemoveEventListener(sub, "click", this._open_submenu.bind(this)));
                    });
                });
            } else {
                addClassToElements(menu, classesNewNavHeader.hidden);
            }
        });
    },
    _open_submenu(ev) {
        let sibbling = ev.target.nextElementSibling;
        if (ev.target.dataset.idx == sibbling.dataset.forIdx) {
            addClassToElements(sibbling, classesNewNavHeader.submenuOpen);
            addOrRemoveEventListener(selectElement("[data-idx]", sibbling), "click", this._close_submenu.bind(this));
        }
    },
    _close_submenu(ev) {
        let parent = ev.target.parentElement;

        removeClassFromElements(parent, classesNewNavHeader.submenuOpen);
    },
    onBlockSelect(block) {
        this.blockSelected = true;
        const target = block.srcElement.dataset.targetId;

        // Open the menu
        this._openNewNavHeader();
    },

    onBlockDeselect() {
        this.blockSelected = false;
        this.container.removeAttribute("open");
    },

    onUnload() {
        // Remove event listeners
        if (this.events.length > 0) this.events.forEach((event) => removeEventListener(event));
    },
});

const selectorsMarquee = {
    slider: ".swiper",
};
register(sectionTypes.announcementMarquee, {
    onLoad() {
        this.marquee = null;
        this.slideshowContainer = selectElement(selectorsMarquee.slider, this.container);
        if (selectElement("sticky-header", this.container.closest("section"))) {
            //controllare se announcement is sticky or not
            document.documentElement.style.setProperty("--announcement-height", this.container.offsetHeight + "px");
        }
        atBreakpointChange(960, this._hanldeinitSlider.bind(this));

        this._hanldeinitSlider();
    },
    _hanldeinitSlider() {
        this.enableSlider = JSON.parse(this.slideshowContainer.dataset.swiperSettings).showSliderOn;
        switch (this.enableSlider) {
            case "everywhere":
                this._initializeCarousel();
                break;
            case "desktop":
                if (window.matchMedia(getMediaQuery("above-960")).matches) {
                    this._initializeCarousel();
                } else {
                    this.marquee && this.marquee.destroy();
                }
                break;
            case "mobile":
                if (window.matchMedia(getMediaQuery("below-960")).matches) {
                    this._initializeCarousel();
                } else {
                    this.marquee && this.marquee.destroy();
                }
                break;
        }
    },
    // initialize carousel
    _initializeCarousel() {
        const { mobileSwiperSettings, desktopSwiperSettings, swiperSettings } = this.slideshowContainer.dataset;

        /**
         * Parse the swiper settings [MOBILE]
         * @type {Object}
         * @property {number} slidesPerView - number of slides per view
         * @property {number} spaceBetween - space between slides
         */
        const mobileSettings = mobileSwiperSettings && JSON.parse(mobileSwiperSettings);
        /**
         * Parse the swiper settings [DESKTOP]
         * @type {Object}
         * @property {number} slidesPerView - number of slides per view
         * @property {number} spaceBetween - space between slides
         * @property {boolean} autoplay - auto play the slider
         */
        const desktopSettings = desktopSwiperSettings && JSON.parse(desktopSwiperSettings);
        /**
         * Parse the swiper settings
         * @type {Object}
         * @property {boolean} freeMode - continuos sliding
         * @property {number} speed - speed of the slider
         * @property {boolean} autoPlay - auto play the slider
         */
        const swiperSettingsObj = swiperSettings && JSON.parse(swiperSettings);
        let swiperOptions = {
            speed: swiperSettingsObj.speed,
            freeMode: swiperSettingsObj.freeMode,
            grabCursor: true,
            loop: true,
            autoplay: swiperSettingsObj.autoplay
                ? {
                      delay: 1,
                      disableOnInteraction: false,
                  }
                : false,
            spaceBetween: mobileSettings.spaceBetween,
            slidesPerView: mobileSettings.slidesPerView,
            effect: swiperSettingsObj.effect,
            breakpoints: {
                960: {
                    spaceBetween: desktopSettings.spaceBetween,
                    slidesPerView: desktopSettings.slidesPerView,
                },
            },
        };

        this.marquee = Carousel(this.slideshowContainer, swiperOptions);
    },

    onBlockSelect({ target }) {
        const slideIndex = target.dataset.swiperSlideIndex;
        if (this.marquee) {
            this.marquee.autoplay.stop();
            this.marquee.slideToLoop(parseInt(slideIndex, 10), 700);
        }
    },
    onBlockDeselect() {
        if (this.marquee) {
            this.marquee.autoplay.start();
        }
    },
    onUnload() {
        this.marquee && this.marquee.destroy();
    },
});

const selectorsSizeGuide = {
    navItems: ".tab",
    tablesContainer: ".tab_pane",
};
const classesSizeGuide = {
    selected: "selected",
    visible: "visible",
    fadeout: "fadeout",
    initReveal: "init-reveal",
    reveal: "reveal",
};
register(sectionTypes.sizeGuide, {
    onLoad() {
        this.events = [];
        // get buttons
        this.navItems = selectElements(selectorsSizeGuide.navItems, this.container);
        this.navItems.forEach((button) =>
            this.events.push(addOrRemoveEventListener(button, "click", this._handleNavButton.bind(this))),
        );

        // get tables
        this.tables = selectElements(selectorsSizeGuide.tablesContainer, this.container);

        if (shouldAnimate(this.container)) {
            this.animateListSlider = animateListSlider(this.container);
        }
    },

    _handleNavButton(e) {
        e.preventDefault();
        // get button
        const { navItem } = e.currentTarget.dataset;

        if (!hasClass(e.currentTarget, classesSizeGuide.selected)) {
            this._hideAll();
            this._show(navItem);
        }
    },
    _hideAll() {
        removeClassFromElements(this.navItems, classesSizeGuide.selected);

        if (shouldAnimate(this.container)) {
            addClassToElements(this.tables, classesSizeGuide.fadeout);
            setTimeout(() => {
                removeClassFromElements(this.tables, classesSizeGuide.visible);
            }, 300);
        } else {
            removeClassFromElements(this.tables, classesSizeGuide.visible);
        }
    },

    _show(item) {
        // addClassToElements(this.container, classesSizeGuide.visible);
        const tab = selectElement(`[data-tab="${item}"]`, this.container);

        if (this.navItems.length > 1) {
            const navItem = selectElement(`[data-nav-item="${item}"]`, this.container);
            addClassToElements(navItem, classesSizeGuide.selected);
        }

        if (shouldAnimate(this.container)) {
            addClassToElements(tab, classesSizeGuide.fadeout);
            addClassToElements(tab, classesSizeGuide.initReveal);
            setTimeout(() => {
                addClassToElements(tab, classesSizeGuide.visible);
                removeClassFromElements(tab, classesSizeGuide.fadeout);
                setTimeout(() => {
                    addClassToElements(tab, classesSizeGuide.reveal);
                }, 50);
            }, 300);
        } else {
            addClassToElements(tab, classesSizeGuide.visible);
        }
    },
});

const selectorsStorySlider = {
        mainContainer: ".carousel_container_scroll",
        dataBlocks: ".story-slider [data-block-data]",
        swiper: ".swiper.carousel_fixed_text_block",
        slide: ".swiper .swiper-slide",
        swiperPrev: ".swiper-button-prev",
        swiperNext: ".swiper-button-next",
        textBoxContainer: ".text_box.init-reveal",
        textBoxMainTitle: ".text_box .text_box-main-title",
        textBoxMainDescription: ".text_box .text_box-main-description",
        textBoxSecondaryLeft: ".text_box .text_box-secondary-left",
        textBoxSecondaryRight: ".text_box .text_box-secondary-right",
    },
    classesStorySlider = {
        animateReveal: "reveal",
    };
register(sectionTypes.storySlider, {
    onLoad() {
        let slideData = [];
        let dataBlocks = document.querySelectorAll(selectorsStorySlider.dataBlocks);
        dataBlocks.forEach((el) => {
            slideData.push(JSON.parse(el.dataset.blockData));
        });
        this.slider = null;
        this.slides = selectElements(selectorsStorySlider.slide, this.container);
        if (this.slides.length > 1) this._initializeCarousel(slideData);
    },
    _initializeCarousel(slideData) {
        import(AF.chunks.swiper).then((_ref) => {
            const { productsPerViewDesktop, productsPerViewTablet, productsPerViewMobile } = this.container.dataset;

            let { Swiper } = _ref;

            const swiperOptions = {
                direction: "horizontal",
                slidesPerView: productsPerViewMobile != "0" ? parseFloat(productsPerViewMobile) : "auto",
                lazy: {
                    enabled: true,
                    loadPrevNext: true,
                },
                speed: 800,
                mousewheel: true,
                touches: true,
                watchOverflow: true,
                allowTouchMove: true,
                simulateTouch: true,
                navigation: {
                    nextEl: selectorsStorySlider.swiperPrev,
                    prevEl: selectorsStorySlider.swiperNext,
                },
                breakpoints: {
                    // when window width is >= 768px
                    768: {
                        slidesPerView: productsPerViewTablet != "0" ? parseFloat(productsPerViewTablet) : "auto",
                    },
                    // when window width is >= 1025x
                    1025: {
                        slidesPerView: productsPerViewDesktop != "0" ? parseFloat(productsPerViewDesktop) : "auto",
                    },
                },
            };

            this.slider = new Swiper(selectorsStorySlider.swiper, swiperOptions);

            const swiper = this.slider;
            const carousel_container = document.querySelector(selectorsStorySlider.mainContainer);

            // BOX CHANGING TEXT ELEMENTS
            const TEXT_BOX = {
                container: selectElement(selectorsStorySlider.textBoxContainer, this.container),
                main_title: selectElement(selectorsStorySlider.textBoxMainTitle, this.container),
                main_description: selectElement(selectorsStorySlider.textBoxMainDescription, this.container),
                secondary_left: selectElement(selectorsStorySlider.textBoxSecondaryLeft, this.container),
                secondary_right: selectElement(selectorsStorySlider.textBoxSecondaryRight, this.container),
            };

            function updateSlideText(index) {
                new Promise((resolve, reject) => {
                    TEXT_BOX.container.style.setProperty("--text_color_desktop", slideData[index].color_desktop);
                    TEXT_BOX.container.style.setProperty("--text_color_mobile", slideData[index].color_mobile);
                    TEXT_BOX.main_title.innerHTML = slideData[index].main_title;
                    TEXT_BOX.main_description.innerHTML = slideData[index].main_description;
                    TEXT_BOX.secondary_left.textContent = slideData[index].secondary_left;
                    TEXT_BOX.secondary_right.textContent = slideData[index].secondary_right;
                    if (
                        TEXT_BOX.main_title.innerHTML ||
                        TEXT_BOX.main_description.innerHTML ||
                        TEXT_BOX.secondary_left.textContent ||
                        TEXT_BOX.secondary_right.textContent
                    ) {
                        resolve();
                    } else {
                        reject();
                    }
                })
                    .then(() => {
                        addClassToElements(TEXT_BOX.container, classesStorySlider.animateReveal);
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }
            // Get all header elements with the class 'header'
            const headers = document.querySelectorAll(this.container.dataset.otherClasses);
            let totalHeight = 0;
            headers &&
                headers.forEach((header) => {
                    const style = getComputedStyle(header);
                    const margin = parseFloat(style.marginTop) + parseFloat(style.marginBottom);
                    totalHeight += header.offsetHeight + margin;
                });

            swiper.on("slideChange", function () {
                setTimeout(function () {
                    swiper.params.touchReleaseOnEdges = false;
                    swiper.params.mousewheel.releaseOnEdges = false;
                    if (window.matchMedia(getMediaQuery("above-767")).matches) {
                        smoothScrollToTarget(carousel_container, totalHeight);
                    }
                });

                // update text box
                updateSlideText(swiper.activeIndex);
            });
            swiper.on("reachEnd", function () {
                setTimeout(function () {
                    swiper.params.touchReleaseOnEdges = true;
                    swiper.params.mousewheel.releaseOnEdges = true;
                }, 500);
            });
            swiper.on("reachBeginning", function () {
                setTimeout(function () {
                    swiper.params.touchReleaseOnEdges = true;
                    swiper.params.mousewheel.releaseOnEdges = true;
                }, 500);
            });

            // Initialize the first slide's text
            updateSlideText(swiper.activeIndex);
        });
    },

    _handleBlockSelect(slideIndex) {
        this.slider.slideTo(parseInt(slideIndex, 10));
        this.slider.autoplay.stop();
    },

    _handleBlockDeselect() {
        let _this$slideshow;

        (_this$slideshow = this.slider) === null || _this$slideshow === void 0
            ? void 0
            : _this$slideshow.autoplay.start();
    },

    onBlockSelect(_ref) {
        const { slide } = _ref.target.dataset;
        if (this.slider) {
            this._handleBlockSelect(slide);
        }
    },
    onBlockDeselect(_ref) {
        const { slide } = _ref.target.dataset;
        if (this.slider) {
            this._handleBlockSelect(slide);
        }
    },
    onSelect() {},
    onDeselect() {},
    onUnload() {},
});

// Function to load all sections and manipulate the classList
const loadSections = () => {
    load("*");
    manipulateClassList({
        SelectedProductSection: null,
    });
};

// Call above function either immediately or bind on loaded event
if (document.readyState === "complete" || document.readyState === "interactive") {
    loadSections();
} else {
    addOrRemoveEventListener(document, "DOMContentLoaded", loadSections);
}

// CREA VARIABILE PER SFONDO cards

(function () {
    "use strict";

    /**
     * Estrae il colore del pixel alle coordinate (x, y) da un'immagine.
     */
    function getPixelColor(img, x, y) {
        try {
            const canvas = document.createElement("canvas");
            canvas.width = img.naturalWidth || img.width;
            canvas.height = img.naturalHeight || img.height;

            const ctx = canvas.getContext("2d", { willReadFrequently: true });
            ctx.drawImage(img, 0, 0);

            // Preleva i dati RGBA del pixel
            const pixel = ctx.getImageData(x, y, 1, 1).data;
            return `rgb(${pixel[0]}, ${pixel[1]}, ${pixel[2]})`;
        } catch (e) {
            // Può accadere se ci sono restrizioni CORS sull'immagine CDN
            console.warn("Impossibile leggere i dati del pixel (CORS o risorsa protetta):", e);
            return null;
        }
    }

    /**
     * Elabora una singola scheda prodotto
     */
    function processCard(cardInner) {
        const images = cardInner.querySelectorAll(".card__media img");
        const firstImg = images[0];
        const secondImg = images[1] || images[0];

        // Funzione helper per elaborare una singola immagine
        const handleImg = (img, cssVarName) => {
            if (!img) return;

            const applyColor = () => {
                // Terzo pixel dall'alto a sinistra: indice (x=2, y=2) basato su 0
                const color = getPixelColor(img, 2, 2);
                if (color) {
                    cardInner.style.setProperty(cssVarName, color);
                }
            };

            if (img.complete && img.naturalWidth > 0) {
                applyColor();
            } else {
                img.addEventListener("load", applyColor, { once: true });
            }
        };

        handleImg(firstImg, "--card-primary-bg");
        handleImg(secondImg, "--card-hover-bg");
    }

    /**
     * Inizializzazione per tutte le card e supporto al caricamento dinamico/AJAX
     */
    function initCardColorExtraction() {
        const cards = document.querySelectorAll(".card-wrapper");
        cards.forEach(processCard);

        // Gestione di eventuali caricamenti dinamici (es. filtri AJAX o paginazione infinita)
        if ("MutationObserver" in window) {
            const observer = new MutationObserver((mutations) => {
                mutations.forEach((mutation) => {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === 1) {
                            if (node.classList && node.classList.contains("card-wrapper")) {
                                processCard(node);
                            } else {
                                const subCards = node.querySelectorAll && node.querySelectorAll(".card-wrapper");
                                if (subCards) subCards.forEach(processCard);
                            }
                        }
                    });
                });
            });

            observer.observe(document.body, { childList: true, subtree: true });
        }
    }

    // Esegue non appena il DOM è pronto (prima del load completo della pagina)
    if (document.readyState === "loading") {
        document.addEventListener("DOMContentLoaded", initCardColorExtraction);
    } else {
        initCardColorExtraction();
    }
})();
